(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sab-cart-redirect"]) return;
  try {
    
  class SabCartRedirect extends HTMLElement {
    /** @type {number | undefined} */
    #timer;

    connectedCallback() {
      // Keep the page visible in the theme editor, so the message can be edited.
      if (window.Shopify?.designMode) return;
      const url = this.dataset.url;
      if (!url) return;
      this.#timer = window.setTimeout(() => window.location.replace(url), 0);
    }

    disconnectedCallback() {
      window.clearTimeout(this.#timer);
    }
  }

  if (!customElements.get('sab-cart-redirect')) customElements.define('sab-cart-redirect', SabCartRedirect);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-footer"]) return;
  try {
    
  /* «Cookie settings» opens the preferences of the Shopify privacy banner, when the banner is on. */
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element) || !target.closest('[data-cookie-settings]')) return;
    window.privacyBanner?.showPreferences?.();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-h-finder"] && !Shopify.designMode) return;
  try {
    
  /* «Find the right book», il gioco del pappagallino (Home v20.4, FINDER.md) + sab-peek.
     Prima il TIPO (categoria del libro, mai allargato), poi età e pubblico; se i libri esatti sono meno di 3 si allarga l'età
     e il fumetto lo dice. Un libro senza età non viene filtrato dall'età e arriva dopo quelli con l'età giusta o vicina.
     Accessibilità: risposte <button aria-pressed>, focus sul titolo del passo, area aria-live per i risultati, tutto da tastiera;
     con «riduci movimento» niente animazioni né attese. */
  if (!customElements.get('sab-finder')) {
    customElements.define('sab-finder', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        else this.init();
      }
      init() {
        if (this._ready) return;
        const doc = document;
        const root = this.querySelector('[data-sab-finder]');
        const dataEl = this.querySelector('[data-finder-books]');
        const copyEl = this.querySelector('[data-finder-copy]');
        if (!root || !dataEl || !copyEl) return;
        let BOOKS = [];
        let COPY = {};
        try { BOOKS = JSON.parse(dataEl.textContent); COPY = JSON.parse(copyEl.textContent); } catch (e) { return; }
        this._ready = true;
        let SHELF = {};
        try { SHELF = JSON.parse(root.dataset.shelves || '{}'); } catch (e) { SHELF = {}; }
        const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const t = (key) => COPY[key];
        const fill = (text, map) => String(text || '').replace(/\{(\w+)\}/g, (_, k) => (k in map ? map[k] : ''));
        /* Edizione: due edizioni dello stesso libro non escono nello stesso giro (Mom & Me Daughter e Son, 300 teal e pink…) */
        const edition = (h) => h.replace(/-(granddaughter|grandson|daughter|son|girls?|boys?|teal|pink|blue|purple)$/, '');
        BOOKS.forEach((b) => { if (!b.g) b.g = edition(b.h); });

        const WHO = {
          child: { ask: 'kid', rel: 'child' },
          grandchild: { ask: 'kid', rel: 'grandchild' },
          family: { ask: 'family', band: 'family' },
          me: { ask: 'me', band: 'adults' },
          friend: { ask: 'gift', gift: true },
          grownup: { ask: 'gift', gift: true, band: 'adults' },
        };
        const BANDS = { little: [3, 5], kids: [6, 8], tweens: [9, 12], teens: [13, 17], adults: [18, 99], family: [6, 99] };
        const LOVES = {
          little: ['color', 'draw', 'stories', 'games', 'facts', 'journal'],
          kids: ['color', 'draw', 'stories', 'games', 'facts', 'journal'],
          tweens: ['color', 'draw', 'stories', 'games', 'facts', 'journal', 'growing'],
          teens: ['color', 'lettering', 'draw', 'games', 'facts', 'growing'],
          adults: ['color', 'lettering', 'growth'],
          family: ['games', 'journal', 'stories', 'color', 'draw', 'facts'],
        };

        const $ = (sel) => root.querySelector(sel);
        const board = $('[data-finder-board]');
        const steps = Object.fromEntries([...root.querySelectorAll('[data-step]')].map((el) => [el.dataset.step, el]));
        const say = $('[data-finder-say]') || $('.sab-finder__mascot .sab-mascot__bubble') || doc.createElement('p');
        const count = $('[data-finder-count]');
        const dots = [...root.querySelectorAll('[data-finder-dots] i')];
        const back = $('[data-finder-back]');
        const live = $('[data-finder-live]');
        const picksEl = $('[data-finder-picks]');
        const resultsTitle = $('[data-finder-results-title]');
        const summary = $('[data-finder-summary]');
        const moreBtn = $('[data-finder-more]');
        const shelf = $('[data-finder-shelf]');
        const loveBox = $('[data-tiles="love"]');
        const loveTiles = Object.fromEntries([...loveBox.querySelectorAll('[data-answer]')].map((b) => [b.dataset.answer, b]));

        const state = { step: 'who', who: null, age: null, love: null, band: null, seen: new Set(), round: 0, last: null, busy: false };
        window.sabFinder = { started: false, focus: (scroll = true) => focusTitle(state.step, scroll) };

        const speak = (fn) => {
          say.textContent = fn();
          if (!motion.matches) { say.classList.remove('is-pop'); void say.offsetWidth; say.classList.add('is-pop'); }
        };
        const flow = () => (state.who && WHO[state.who].band ? ['who', 'love'] : ['who', 'age', 'love']);
        const paintTop = () => {
          const seq = flow();
          const total = seq.length;
          const n = state.step === 'results' ? total : Math.max(1, seq.indexOf(state.step) + 1);
          count.textContent = fill(t('count'), { n, total });
          count.parentElement.hidden = state.step === 'results';
          dots.forEach((d, i) => { d.hidden = i >= total; d.classList.toggle('is-on', i < n); });
          back.hidden = state.step === 'who';
          root.querySelectorAll('[data-path]').forEach((li) => {
            const k = li.dataset.path;
            const done = (k === 'who' && state.who) || (k === 'age' && (state.age || (state.who && WHO[state.who].band))) || (k === 'love' && state.love && state.step === 'results');
            li.classList.toggle('is-done', Boolean(done) && state.step !== k);
            li.classList.toggle('is-now', state.step === k);
          });
        };

        const focusTitle = (step, scroll) => {
          const title = steps[step] && steps[step].querySelector('.sab-finder__title');
          if (!title) return;
          title.focus({ preventScroll: true });
          if (!scroll) return;
          const head = doc.querySelector('.sab-header');
          const headH = (head ? head.offsetHeight : 0) + 12;
          const r = board.getBoundingClientRect();
          const tr = title.getBoundingClientRect();
          if (r.top < headH || tr.bottom > window.innerHeight * 0.55) {
            window.scrollTo({ top: window.scrollY + r.top - headH, behavior: motion.matches ? 'auto' : 'smooth' });
          }
        };

        const prepareLove = () => {
          const ask = WHO[state.who].ask;
          steps.love.querySelectorAll('[data-ask]').forEach((el) => { el.hidden = el.dataset.ask !== ask; });
          const list = LOVES[state.band];
          Object.entries(loveTiles).forEach(([k, b]) => { b.hidden = !list.includes(k); b.classList.remove('is-wide'); });
          list.forEach((k) => loveBox.appendChild(loveTiles[k]));
          if (list.length % 2) loveTiles[list[list.length - 1]].classList.add('is-wide');
        };

        const show = (step, { focus = true } = {}) => {
          state.step = step;
          Object.entries(steps).forEach(([k, el]) => { el.hidden = k !== step; });
          if (step === 'love') prepareLove();
          paintTop();
          if (focus) focusTitle(step, true);
        };

        const known = (b) => typeof b.min === 'number';
        const dist = (b, [lo, hi]) => (!known(b) ? 0 : b.max < lo ? lo - b.max : b.min > hi ? b.min - hi : 0);
        /* 0 = età giusta (oppure, senza età, il diario di coppia giusto o il libro da fare insieme per «tutta la famiglia»), 1 = età vicina, 2 = senza età */
        const tier = (b, d, x, together) => (known(b) ? (d === 0 ? 0 : 1) : x === 0 || together ? 0 : 2);
        const ranked = () => {
          const band = BANDS[state.band];
          const rel = WHO[state.who].rel;
          return BOOKS.filter((b) => b.type === state.love)
            .map((b) => {
              const d = dist(b, band);
              const x = !b.rel ? 1 : b.rel === rel ? 0 : 2;
              const together = state.band === 'family' && Boolean(b.fam);
              return { b, d, x, k: tier(b, d, x, together), f: state.band === 'family' && !together ? 1 : 0 };
            })
            .sort((p, q) => p.f - q.f || p.k - q.k || p.d - q.d || p.x - q.x || p.b.r - q.b.r);
        };
        const nextRound = () => {
          const pool = ranked().filter((p) => !state.seen.has(p.b.h));
          const pick = [];
          const groups = new Set();
          const take = (list, oneEdition) => list.forEach((p) => {
            if (pick.length === 3 || pick.includes(p) || (oneEdition && groups.has(p.b.g))) return;
            pick.push(p); groups.add(p.b.g);
          });
          const exact = pool.filter((p) => p.k === 0);
          const near = pool.filter((p) => p.k === 1);
          const unknown = pool.filter((p) => p.k === 2);
          take(exact, true); take(exact, false); take(near, true); take(near, false); take(unknown, true); take(unknown, false);
          pick.forEach((p) => state.seen.add(p.b.h));
          return { pick, left: pool.length - pick.length, round: ++state.round };
        };
        const noteFor = (pick) => {
          const withAge = pick.filter((p) => known(p.b));
          if (!withAge.some((p) => p.d > 0)) return null;
          const band = BANDS[state.band];
          const all = BOOKS.filter((b) => b.type === state.love && known(b));
          const typeMin = Math.min(...all.map((b) => b.min));
          const typeMax = Math.max(...all.map((b) => b.max));
          if (withAge.every((p) => p.d > 0) && !pick.some((p) => p.k === 0)) {
            if (typeMin >= 13 && typeMin > band[1]) return t('older_teens');
            if (state.band === 'little' && typeMin === 6) return t('start6');
            if (typeMin > band[1]) return fill(t('older'), { min: typeMin });
            if (typeMax < band[0]) return t('younger');
          }
          return t('near');
        };

        const card = (p, i) => {
          const b = p.b;
          const li = doc.createElement('li');
          li.className = 'sab-pick';
          li.dataset.cat = b.cat;
          li.style.setProperty('--sab-i', i);
          const stage = doc.createElement('span');
          stage.className = 'sab-cover sab-pick__cover';
          stage.dataset.cat = b.cat;
          stage.style.setProperty('--trim', b.tr || (b.iw && b.ih ? `${b.iw}/${b.ih}` : '2/3'));
          if (b.ra) stage.style.setProperty('--ratio', b.ra);
          const book = doc.createElement('span');
          book.className = 'sab-cover__book';
          if (b.img) {
            const img = doc.createElement('img');
            img.className = 'sab-cover__img';
            img.src = b.img;
            if (b.img2) { img.srcset = `${b.img} 240w, ${b.img2} 480w`; img.sizes = '(min-width: 64rem) 12rem, 60vw'; }
            img.width = b.iw; img.height = b.ih; img.alt = ''; img.decoding = 'async';
            book.append(img);
          }
          stage.append(book);
          const cat = doc.createElement('p');
          cat.className = 'sab-pick__cat';
          const dot = doc.createElement('span');
          dot.className = 'sab-pick__dot';
          dot.setAttribute('aria-hidden', 'true');
          cat.append(dot, (t('cats') || {})[b.cat] || '');
          const title = doc.createElement('h4');
          title.className = 'sab-pick__title';
          title.textContent = b.t;
          const a = doc.createElement('a');
          a.className = 'sab-btn sab-btn--sm sab-btn--outline sab-pick__btn';
          a.href = b.u || `/products/${b.h}`;
          a.append(t('see'));
          const sr = doc.createElement('span');
          sr.className = 'sab-visually-hidden';
          sr.textContent = `: ${b.t}`;
          a.append(sr);
          li.append(stage, cat, title, a);
          return li;
        };
        const tileText = (step, value, sel = '.sab-finder__label') => {
          const tile = steps[step] && steps[step].querySelector(`[data-answer="${value}"]`);
          const el = tile && tile.querySelector(sel);
          return el ? el.textContent.trim() : '';
        };
        const headline = (n) => {
          const w = WHO[state.who];
          if (state.who === 'me') return t('title_me')[n];
          return fill(t(w.gift ? 'title_gift' : 'title')[n], { who: t('who')[state.who] });
        };
        const renderResults = (round, { announce = true, animate = true } = {}) => {
          state.last = round;
          const { pick, left } = round;
          const n = pick.length;
          resultsTitle.textContent = headline(n) || '';
          summary.textContent = [tileText('who', state.who), state.age ? tileText('age', state.age, '.sab-finder__hint') : '', tileText('love', state.love)]
            .filter(Boolean).join(' · ');
          picksEl.replaceChildren(...pick.map(card));
          picksEl.scrollLeft = 0;
          picksEl.classList.toggle('is-dealing', animate && !motion.matches);
          moreBtn.hidden = left === 0;
          shelf.hidden = left > 0;
          if (SHELF[state.love]) shelf.href = SHELF[state.love];
          const note = noteFor(pick);
          const line = () => note || (left === 0 && round.round > 1 ? t('last') : left === 0 && n < 3 ? t('few')[n] : round.round === 1 ? t('picks') : t('more')[n]);
          speak(line);
          if (announce) {
            const titles = pick.map((p) => p.b.t);
            const list = titles.length > 1 ? `${titles.slice(0, -1).join(', ')} ${t('and')} ${titles[titles.length - 1]}` : (titles[0] || '');
            live.textContent = '';
            window.setTimeout(() => { live.textContent = `${resultsTitle.textContent}. ${note ? `${note} ` : ''}${list}.`; }, 60);
          }
        };
        const reveal = (round) => {
          state.busy = true;
          board.setAttribute('aria-busy', 'true');
          const done = () => {
            state.busy = false;
            board.removeAttribute('aria-busy');
            show('results', { focus: false });
            renderResults(round);
            focusTitle('results', true);
          };
          if (motion.matches) { done(); return; }
          speak(() => t('thinking'));
          window.setTimeout(done, 650);
        };

        const press = (btn) => {
          btn.closest('[data-step]').querySelectorAll('[data-answer]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
        };
        const answer = (step, value) => {
          if (step === 'who') {
            state.who = value; state.age = null; state.love = null;
            state.band = WHO[value].band || null;
            root.querySelectorAll('[data-step="age"] [data-answer], [data-step="love"] [data-answer]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
            window.sabFinder.started = true;
            speak(() => t('react_who')[state.who]);
            show(state.band ? 'love' : 'age');
          } else if (step === 'age') {
            state.age = value; state.band = value; state.love = null;
            loveBox.querySelectorAll('[data-answer]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
            speak(() => t('react_age'));
            show('love');
          } else if (step === 'love') {
            state.love = value; state.seen = new Set(); state.round = 0;
            reveal(nextRound());
          }
        };

        root.addEventListener('click', (event) => {
          const btn = event.target.closest('[data-answer]');
          if (btn && !state.busy) {
            const step = btn.closest('[data-step]').dataset.step;
            press(btn);
            if (motion.matches) answer(step, btn.dataset.answer);
            else { btn.classList.add('is-picked'); window.setTimeout(() => { btn.classList.remove('is-picked'); answer(step, btn.dataset.answer); }, 170); }
            return;
          }
          if (event.target.closest('[data-finder-back]')) {
            const seq = flow();
            const prev = state.step === 'results' ? 'love' : seq[seq.indexOf(state.step) - 1];
            if (!prev) return;
            speak(() => (prev === 'who' ? t('hello') : prev === 'age' ? t('react_who')[state.who] : t('react_age')));
            show(prev);
            return;
          }
          if (event.target.closest('[data-finder-more]')) {
            renderResults(nextRound());
            focusTitle('results', true);
            return;
          }
          if (event.target.closest('[data-finder-restart]')) {
            Object.assign(state, { who: null, age: null, love: null, band: null, seen: new Set(), round: 0, last: null });
            root.querySelectorAll('[data-answer]').forEach((b) => b.setAttribute('aria-pressed', 'false'));
            live.textContent = '';
            speak(() => t('hello'));
            show('who');
          }
        });

        paintTop();
      }
    });
  }

  /* sab-peek · il pappagallino che spunta: una volta per sessione, dopo il 30% di pagina; si fa da parte sopra banner, gioco,
     footer, finestre aperte e qualsiasi link, bottone o campo; un tocco porta al gioco; la × lo nasconde per la sessione. */
  if (!customElements.get('sab-peek')) {
    customElements.define('sab-peek', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        else this.init();
      }
      init() {
        if (this._ready) return;
        this._ready = true;
        const doc = document;
        const root = this;
        const KEY = 'sab-peek-seen';
        const read = () => { try { return sessionStorage.getItem(KEY); } catch (e) { return null; } };
        const write = (v) => { try { sessionStorage.setItem(KEY, v); } catch (e) { /* storage bloccato */ } };
        if (read()) return;
        const link = root.querySelector('[data-peek-go]');
        const id = link ? (link.getAttribute('href') || '').replace('#', '') : 'finder';
        const finder = doc.getElementById(id);
        const watch = { hero: doc.querySelector('[data-sab-slideshow]'), finder, footer: doc.querySelector('.sab-footer') };
        const inView = { hero: true, finder: false, footer: false };
        let shown = false;
        let done = false;
        let ticking = false;
        const INTERACTIVE = 'a[href], button, input, select, textarea, summary, label, [role="button"], [tabindex]:not([tabindex="-1"])';
        const overControl = () => {
          const r = root.getBoundingClientRect();
          if (!r.width) return false;
          const pts = [[r.left + r.width / 2, r.top + r.height / 2], [r.left + 6, r.top + 6], [r.right - 6, r.top + 6], [r.left + 6, r.bottom - 6], [r.right - 6, r.bottom - 6]];
          return pts.some(([x, y]) => doc.elementsFromPoint(x, y).some((el) => !root.contains(el) && el.closest(INTERACTIVE)));
        };
        const away = () => inView.hero || inView.finder || inView.footer || Boolean(doc.querySelector('dialog[open]')) || overControl();
        const update = () => {
          if (done) return;
          if (!shown) {
            const max = doc.documentElement.scrollHeight - window.innerHeight;
            const ratio = max > 0 ? window.scrollY / max : 0;
            if (ratio < 0.3 || (window.sabFinder && window.sabFinder.started) || inView.hero || inView.finder || inView.footer) return;
            shown = true;
            write('1');
            root.hidden = false;
            requestAnimationFrame(() => root.classList.add('is-in'));
          }
          root.classList.toggle('is-away', away());
        };
        if ('IntersectionObserver' in window) {
          Object.entries(watch).forEach(([k, el]) => {
            if (!el) { inView[k] = false; return; }
            new IntersectionObserver(([e]) => { inView[k] = e.isIntersecting; update(); }).observe(el);
          });
        } else {
          inView.hero = false;
        }
        const onScroll = () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => { ticking = false; update(); });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        const close = () => {
          done = true;
          root.classList.add('is-away');
          window.setTimeout(() => { root.hidden = true; }, 250);
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
        };
        const closeBtn = root.querySelector('[data-peek-close]');
        if (closeBtn) closeBtn.addEventListener('click', close);
        if (link) link.addEventListener('click', (event) => {
          if (!finder) return;
          event.preventDefault();
          close();
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          finder.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          window.history.replaceState(null, '', `#${id}`);
          if (window.sabFinder) window.sabFinder.focus(false);
        });
        root.addEventListener('keydown', (event) => { if (event.key === 'Escape') close(); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-h-row"] && !Shopify.designMode) return;
  try {
    
  /* sab-rail · file orizzontali con frecce sotto la fila e schede «New releases / Our picks» (aria-pressed).
     Senza JS si vede la prima fila e si scorre col dito. */
  if (!customElements.get('sab-rail')) {
    customElements.define('sab-rail', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        else this.init();
      }
      init() {
        if (this._ready) return;
        this._ready = true;
        const prev = this.querySelector('[data-rail-prev]');
        const next = this.querySelector('[data-rail-next]');
        const track = () => this.querySelector('[data-rail-track]:not([hidden])');
        const step = () => {
          const first = track() && track().querySelector(':scope > *');
          return (first ? first.getBoundingClientRect().width : 240) + 16;
        };
        const update = () => {
          const t = track();
          if (!t || !prev || !next) return;
          prev.disabled = t.scrollLeft < 8;
          next.disabled = t.scrollLeft + t.clientWidth > t.scrollWidth - 8;
        };
        if (prev && next) {
          prev.addEventListener('click', () => { const t = track(); if (t) t.scrollBy({ left: -step(), behavior: 'smooth' }); });
          next.addEventListener('click', () => { const t = track(); if (t) t.scrollBy({ left: step(), behavior: 'smooth' }); });
        }
        this.querySelectorAll('[data-rail-track]').forEach((t) => t.addEventListener('scroll', update, { passive: true }));
        window.addEventListener('resize', update);

        const tabs = [...this.querySelectorAll('[data-tab-target]')];
        tabs.forEach((tab) => tab.addEventListener('click', () => {
          tabs.forEach((t) => {
            const on = t === tab;
            t.setAttribute('aria-pressed', String(on));
            const panel = document.getElementById(t.dataset.tabTarget);
            if (panel) { panel.hidden = !on; if (on) panel.scrollLeft = 0; }
          });
          update();
        }));
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-h-slideshow"] && !Shopify.designMode) return;
  try {
    
  /* sab-slideshow (Home, 18/10/2026) · frecce ai lati, pallini sotto, dito e tasti freccia. La pista scorre in modo nativo
     (scroll-snap): il dito la muove il telefono; frecce, pallini, tasti e autoplay la fanno scorrere con scrollTo.
     Autoplay: il tempo lo misura il riempimento della pillola attiva (Web Animations), così mouse sopra, focus, dito giù,
     banner fuori schermo o scheda nascosta lo mettono in pausa e poi riprende da dove era. Un clic su freccia o pallino,
     uno swipe o un tasto freccia lo fermano per sempre (l'utente ha preso il controllo). Mai con prefers-reduced-motion.
     Solo la prima slide si scarica col caricamento: le altre hanno le immagini in data-srcset/data-src e le ricevono quando
     la slide si apre, quando dito, mouse o focus si avvicinano (slide vicine), all'inizio di ogni giro d'autoplay (la
     seguente) e, a riposo dopo il «load», la slide seguente. */
  if (!customElements.get('sab-slideshow')) {
    customElements.define('sab-slideshow', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        else this.init();
      }
      init() {
        if (this._ready) return;
        const root = this.querySelector('[data-sab-slideshow]');
        if (!root) return;
        this._ready = true;
        const slides = [...root.querySelectorAll('[data-slide-item]')];
        const dots = [...root.querySelectorAll('[data-slide-dot]')];
        const track = root.querySelector('[data-slides]');
        const stage = root.querySelector('[data-stage]');
        if (!slides.length || !track) return;
        const len = slides.length;
        let index = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));
        const motionQ = window.matchMedia('(prefers-reduced-motion: reduce)');
        const wideQ = window.matchMedia('(min-width: 64rem)');

        const hydrate = (slide) => {
          if (!slide || slide.dataset.hydrated) return;
          slide.dataset.hydrated = '1';
          slide.querySelectorAll('source[data-srcset]').forEach((el) => { el.srcset = el.dataset.srcset; el.removeAttribute('data-srcset'); });
          slide.querySelectorAll('img[data-srcset], img[data-src]').forEach((img) => {
            if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
            if (img.dataset.src) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
          });
        };
        const at = (i) => slides[((i % len) + len) % len];
        const hydrateNear = () => [index - 1, index, index + 1].forEach((i) => hydrate(at(i)));

        /* Frecce a metà dell'artwork: telefono = metà dell'immagine in alto, da 64rem = metà del banner. Le immagini del
           telefono non hanno tutte la stessa proporzione: si prende la metà più bassa, così le frecce non si spostano
           da una slide all'altra (il dito o il mouse ripremono nello stesso punto). */
        const placeArrows = () => {
          if (!stage) return;
          const top = track.getBoundingClientRect().top;
          let y = Infinity;
          slides.forEach((s) => {
            const art = s.querySelector('.sab-banner__art');
            const a = art && art.getBoundingClientRect();
            if (a && a.height) y = Math.min(y, a.top - top + a.height / 2);
          });
          if (y !== Infinity) stage.style.setProperty('--sab-arrow-y', `${Math.round(y)}px`);
        };

        /* Scorrimento della pista. «auto» = lo scorrimento l'ha chiesto il JS (freccia, pallino, tasto, autoplay): finché
           non arriva, gli eventi «scroll» non contano come gesto del visitatore. */
        let auto = false;
        let autoT = 0;
        let target = index;
        const goTo = (i, smooth) => {
          const left = slides[i].offsetLeft;
          if (Math.abs(track.scrollLeft - left) < 2) { auto = false; return; }
          auto = true;
          target = i;
          clearTimeout(autoT);
          autoT = setTimeout(() => { auto = false; }, 1500);
          track.scrollTo({ left, behavior: smooth && !motionQ.matches ? 'smooth' : 'auto' });
        };

        /* Autoplay */
        const delay = Math.round(Number(this.dataset.autoplay || 0));
        let stopped = !delay || motionQ.matches || len < 2 || !track.animate || !track.scrollTo;
        let started = false;
        let hovering = false;
        let focused = false;
        let touching = false;
        let inView = true;
        let fill = null;
        const paused = () => hovering || focused || touching || !inView || document.hidden;
        if (stopped) root.classList.add('is-stopped');

        const runFill = () => {
          if (fill) { fill.onfinish = null; fill.cancel(); fill = null; }
          if (stopped || !started) return;
          const bar = (dots[index] && dots[index].querySelector('.sab-hero__fill')) || track;
          const frames = bar === track ? [] : [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }];
          fill = bar.animate(frames, { duration: delay, easing: 'linear', fill: 'forwards' });
          fill.onfinish = () => { fill = null; show(index + 1, false); };
          if (paused()) fill.pause();
          hydrate(at(index + 1));
        };

        /* setActive = stato (classe, inert, pallini, autoplay, video) senza muovere la pista; show = setActive + scorrimento */
        const setActive = (n, announce) => {
          index = ((n % len) + len) % len;
          hydrate(slides[index]);
          if (announce) hydrateNear();
          slides.forEach((s, i) => {
            const on = i === index;
            s.classList.toggle('is-active', on);
            s.inert = !on;
            s.setAttribute('aria-hidden', String(!on));
          });
          dots.forEach((t, i) => t.setAttribute('aria-current', String(i === index)));
          track.setAttribute('aria-live', announce ? 'polite' : 'off');
          placeArrows();
          runFill();
          syncVideos();
        };
        const show = (n, announce, smooth = true) => {
          setActive(n, announce);
          goTo(index, smooth);
        };
        this.show = show;

        const stop = () => {
          if (!stopped) {
            stopped = true;
            root.classList.add('is-stopped');
          }
          if (fill) { fill.onfinish = null; fill.cancel(); fill = null; }
          syncVideos();
        };
        const sync = () => {
          if (fill) {
            if (paused()) fill.pause();
            else if (fill.playState === 'paused') fill.play();
          }
          syncVideos();
        };
        this.stop = stop;

        /* Comandi: frecce, pallini, tastiera, dito */
        const prevBtn = root.querySelector('[data-slide-prev]');
        const nextBtn = root.querySelector('[data-slide-next]');
        if (prevBtn) {
          prevBtn.addEventListener('click', () => { stop(); show(index - 1, true); });
          ['pointerenter', 'focus'].forEach((ev) => prevBtn.addEventListener(ev, () => hydrate(at(index - 1))));
        }
        if (nextBtn) {
          nextBtn.addEventListener('click', () => { stop(); show(index + 1, true); });
          ['pointerenter', 'focus'].forEach((ev) => nextBtn.addEventListener(ev, () => hydrate(at(index + 1))));
        }
        dots.forEach((t) => {
          const i = Number(t.dataset.slideDot);
          t.addEventListener('click', () => { stop(); if (i !== index) show(i, true); });
          const warm = () => hydrate(slides[i]);
          t.addEventListener('pointerenter', warm);
          t.addEventListener('focus', warm);
        });
        root.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          if (e.altKey || e.ctrlKey || e.metaKey || e.target.closest('input, textarea, select')) return;
          const dir = e.key === 'ArrowRight' ? 1 : -1;
          const onDot = e.target.closest('[data-slide-dot]');
          const inSlide = e.target.closest('[data-slide-item]');
          e.preventDefault();
          stop();
          show(index + dir, true);
          if (onDot && dots[index]) dots[index].focus();
          else if (inSlide) { const t = slides[index].querySelector('a[href], button') || dots[index]; if (t) t.focus(); }
        });

        /* Dito: lo scorrimento è del telefono. Dito giù = pausa dell'autoplay; se la pista si muove per un gesto del visitatore
           l'autoplay si ferma per sempre e la slide più vicina diventa quella attiva (pallini aggiornati mentre scorre). */
        root.addEventListener('pointerdown', hydrateNear, { passive: true });
        track.addEventListener('touchstart', () => { touching = true; auto = false; hydrateNear(); sync(); }, { passive: true });
        const lift = () => { touching = false; sync(); };
        track.addEventListener('touchend', lift, { passive: true });
        track.addEventListener('touchcancel', lift, { passive: true });
        let scrollRaf = 0;
        track.addEventListener('scroll', () => {
          if (scrollRaf) return;
          scrollRaf = requestAnimationFrame(() => {
            scrollRaf = 0;
            const step = len > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth;
            if (!step) return;
            const i = Math.max(0, Math.min(len - 1, Math.round(track.scrollLeft / step)));
            if (auto) {
              if (i === target && Math.abs(track.scrollLeft - slides[i].offsetLeft) < 2) { auto = false; clearTimeout(autoT); }
              return;
            }
            /* ferma sulla slide attiva (ultimi eventi dello scorrimento del JS, scatto finale): non è un gesto */
            if (Math.abs(track.scrollLeft - slides[index].offsetLeft) < 2) return;
            stop();
            if (i !== index) setActive(i, true);
            hydrate(at(i - 1));
            hydrate(at(i + 1));
          });
        }, { passive: true });

        root.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') { hovering = true; sync(); } });
        root.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') { hovering = false; sync(); } });
        root.addEventListener('focusin', () => { focused = true; sync(); });
        root.addEventListener('focusout', (e) => { if (!root.contains(e.relatedTarget)) { focused = false; sync(); } });
        document.addEventListener('visibilitychange', sync);
        if ('IntersectionObserver' in window) {
          new IntersectionObserver((entries) => {
            const e = entries[entries.length - 1];
            inView = e.isIntersecting && e.intersectionRatio >= 0.25;
            sync();
          }, { threshold: [0, 0.25, 0.5] }).observe(root);
        }
        /* Cambio di larghezza (rotazione, finestra): la pista resta sulla slide attiva */
        if ('ResizeObserver' in window) new ResizeObserver(() => { placeArrows(); if (!touching) goTo(index, false); }).observe(track);

        /* Editor del tema: il blocco scelto diventa la slide visibile e l'autoplay si ferma */
        document.addEventListener('shopify:block:select', (e) => {
          const i = slides.indexOf(e.target.closest ? e.target.closest('[data-slide-item]') : null);
          if (i > -1) { stop(); show(i, false, false); }
        });

        /* Loop video facoltativo (data-video-d/-d2/-m/-m2 sulla slide, URL separati da spazio): mai nell'HTML iniziale, così
           l'immagine resta l'LCP. Dopo il «load» si crea sopra l'immagine e gira solo se la sua slide è attiva, l'autoplay è
           acceso e non in pausa (mouse sopra, focus, dito, fuori schermo, scheda nascosta) né fermato da un comando; mai con
           prefers-reduced-motion o Risparmio dati: lì resta l'immagine. Si scarica un file solo: arte desktop quando vale il
           <source> del <picture> (da 80rem), 2x solo su schermi 2dppx da 64rem (il telefono ha sempre l'1x), webm prima di mp4.
           Errore o play() rifiutato: il video sparisce e resta l'immagine. */
        const vidSlides = slides.filter((s) => s.dataset.videoD || s.dataset.videoD2 || s.dataset.videoM || s.dataset.videoM2);
        const videos = new Map();
        const failed = new Set();
        let loaded = false;
        let probe = null;
        const hiQ = window.matchMedia('(min-resolution: 2dppx), (-webkit-min-device-pixel-ratio: 2)');
        const deskSrc = root.querySelector('.sab-banner__art source[media]');
        const deskQ = window.matchMedia(deskSrc ? deskSrc.media : '(min-width: 80rem)');
        const types = { webm: 'video/webm; codecs="vp9"', mp4: 'video/mp4', m4v: 'video/mp4', mov: 'video/quicktime' };
        const ext = (u) => u.split(/[?#]/)[0].split('.').pop().toLowerCase();
        const pickVideo = (slide) => {
          const d = slide.dataset;
          if (!slide.querySelector('.sab-banner__art img')) return '';
          const desk = deskQ.matches && !!slide.querySelector('.sab-banner__art source[media]');
          const hi = hiQ.matches && wideQ.matches;
          const list = desk ? (hi && d.videoD2) || d.videoD : (hi && d.videoM2) || d.videoM;
          if (!list) return '';
          probe = probe || document.createElement('video');
          const ok = (u) => probe.canPlayType(types[ext(u)] || 'video/mp4') !== '';
          const urls = list.split(/[\s,]+/).filter((u) => /^(https:\/\/|\/)/.test(u));
          return urls.find((u) => ext(u) === 'webm' && ok(u)) || urls.find((u) => ext(u) !== 'webm' && ok(u)) || '';
        };
        const owns = (slide, el) => { const c = videos.get(slide); return !!c && c.el === el; };
        const dropVideo = (slide, fail) => {
          const c = videos.get(slide);
          if (c) {
            videos.delete(slide);
            c.el.pause();
            c.el.remove();
            c.el.removeAttribute('src');
            c.el.load();
          }
          if (fail) failed.add(slide);
        };
        const makeVideo = (slide, url) => {
          const art = slide.querySelector('.sab-banner__art');
          const img = art.querySelector('img');
          const v = document.createElement('video');
          v.className = 'sab-banner__video';
          v.muted = true;
          ['muted', 'loop', 'playsinline', 'disablepictureinpicture', 'disableremoteplayback'].forEach((a) => v.setAttribute(a, ''));
          v.setAttribute('preload', 'none');
          v.setAttribute('aria-hidden', 'true');
          v.setAttribute('tabindex', '-1');
          if (img.currentSrc && !img.currentSrc.startsWith('data:')) v.poster = img.currentSrc;
          const w = img.getAttribute('width');
          const h = img.getAttribute('height');
          if (w && h) v.style.setProperty('--sab-video-ar', `${w} / ${h}`);
          v.addEventListener('playing', () => v.classList.add('is-playing'));
          v.addEventListener('error', () => { if (owns(slide, v)) dropVideo(slide, true); });
          v.src = url;
          art.after(v);
          return v;
        };
        function syncVideos() {
          if (!loaded) return;
          const off = motionQ.matches || !!(navigator.connection && navigator.connection.saveData);
          const run = !off && !stopped && !paused();
          vidSlides.forEach((slide) => {
            if (failed.has(slide)) return;
            const url = off ? '' : pickVideo(slide);
            let c = videos.get(slide);
            if (c && c.url !== url) { dropVideo(slide, false); c = null; }
            if (!url) return;
            if (!run || slide !== slides[index]) { if (c) c.el.pause(); return; }
            if (!c) { c = { url, el: makeVideo(slide, url) }; videos.set(slide, c); }
            if (!c.el.paused) return;
            const el = c.el;
            const p = el.play();
            if (p && p.catch) p.catch((err) => { if (!(err && err.name === 'AbortError') && owns(slide, el)) dropVideo(slide, true); });
          });
        }

        show(index, false, false);
        const onLoad = (fn) => { if (document.readyState === 'complete') fn(); else window.addEventListener('load', fn, { once: true }); };
        onLoad(() => { placeArrows(); if (!stopped) { started = true; runFill(); } });
        const next = () => { if (!(navigator.connection && navigator.connection.saveData)) { hydrate(at(index + 1)); hydrate(at(index - 1)); } };
        onLoad(() => (window.requestIdleCallback ? window.requestIdleCallback(next, { timeout: 3000 }) : window.setTimeout(next, 1200)));

        if (vidSlides.length) {
          onLoad(() => { loaded = true; syncVideos(); });
          [motionQ, hiQ, wideQ, deskQ].forEach((q) => { if (q.addEventListener) q.addEventListener('change', syncVideos); });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-h-story"] && !Shopify.designMode) return;
  try {
    
  /* sab-lazy-bg · i motivi di sfondo (--sab-pattern) si scaricano solo quando il riquadro è a meno di 600 px dallo schermo (P-12) */
  if (!customElements.get('sab-lazy-bg')) {
    customElements.define('sab-lazy-bg', class extends HTMLElement {
      connectedCallback() {
        if (!('IntersectionObserver' in window)) { this.classList.add('is-near'); return; }
        this._io = new IntersectionObserver((entries) => entries.forEach((e) => {
          if (e.isIntersecting) { this.classList.add('is-near'); this._io.disconnect(); }
        }), { rootMargin: '600px 0px' });
        this._io.observe(this);
      }
      disconnectedCallback() { if (this._io) this._io.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-header"]) return;
  try {
    
  /**
   * sab-header: «Books» mega menu (disclosure: Esc, click outside, links with data-mega-close) and the menu dialog,
   * closed when the window grows to the desktop header. Dialog opening and the scroll shadow are in assets/sab-base.js.
   */
  if (!customElements.get('sab-header')) {
    class SabHeader extends HTMLElement {
      #controller = null;

      connectedCallback() {
        this.#controller = new AbortController();
        const { signal } = this.#controller;
        const header = this.querySelector('.sab-header');

        const setMega = (button, open) => {
          const panel = document.getElementById(button.getAttribute('aria-controls') || '');
          button.setAttribute('aria-expanded', String(open));
          if (panel) panel.hidden = !open;
          header?.classList.toggle('is-mega-open', Boolean(this.querySelector('[data-mega-toggle][aria-expanded="true"]')));
        };
        const closeAll = (except) => {
          for (const button of this.querySelectorAll('[data-mega-toggle][aria-expanded="true"]')) {
            if (button !== except) setMega(button, false);
          }
        };

        for (const button of this.querySelectorAll('[data-mega-toggle]')) {
          button.addEventListener(
            'click',
            () => {
              const open = button.getAttribute('aria-expanded') !== 'true';
              closeAll(button);
              setMega(button, open);
            },
            { signal },
          );
          /* When focus leaves the mega menu with Tab, the panel closes (a click on a non-focusable part keeps it open) */
          const item = button.closest('.sab-header__item--mega');
          item?.addEventListener(
            'focusout',
            () =>
              window.setTimeout(() => {
                const now = document.activeElement;
                if (now && now !== document.body && !item.contains(now)) setMega(button, false);
              }, 0),
            { signal },
          );
        }

        document.addEventListener(
          'keydown',
          (event) => {
            if (event.key !== 'Escape') return;
            const open = this.querySelector('[data-mega-toggle][aria-expanded="true"]');
            if (!open) return;
            setMega(open, false);
            open.focus();
          },
          { signal },
        );

        document.addEventListener(
          'click',
          (event) => {
            const target = event.target;
            if (!(target instanceof Element)) return;
            if (!target.closest('.sab-header__item--mega') || target.closest('[data-mega-close]')) closeAll(null);
          },
          { signal },
        );

        window.matchMedia('(min-width: 70rem)').addEventListener(
          'change',
          (event) => {
            if (event.matches) this.querySelector('dialog.sab-menu[open]')?.close();
            else closeAll(null);
          },
          { signal },
        );
      }

      disconnectedCallback() {
        this.#controller?.abort();
      }
    }
    customElements.define('sab-header', SabHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-join"] && !Shopify.designMode) return;
  try {
    
  /* sab-join-form · MailerLite Classic senza i loro script (D-76): controllo dell'email e del consenso nel browser, poi
     SAB.mlSubmit (assets/sab-base.js, JSONP come lo script ufficiale del Classic) con fields[email], ml-submit, anticsrf,
     ajax + i campi nascosti della sezione. Successo SOLO con { success: true } di MailerLite; altrimenti errore nel campo
     aria-live e bottone di nuovo attivo. Nessun successo ottimistico. */
  if (!customElements.get('sab-join-form')) {
    customElements.define('sab-join-form', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        else this.init();
      }
      init() {
        if (this._ready) return;
        const form = this.querySelector('form');
        if (!form) return;
        this._ready = true;
        const input = form.querySelector('input[type="email"]');
        const agree = form.querySelector('input[type="checkbox"]');
        const error = form.querySelector('.sab-news__error');
        const button = form.querySelector('button[type="submit"]');
        const d = this.dataset;
        const say = (msg, ok) => {
          error.hidden = !msg;
          error.textContent = msg || '';
          error.classList.toggle('is-ok', Boolean(ok));
        };
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          if (form.classList.contains('is-sent') || form.classList.contains('is-busy')) return;
          const value = input.value.trim();
          let msg = '';
          if (!value) msg = d.msgEmpty;
          else if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value)) msg = d.msgInvalid;
          input.setAttribute('aria-invalid', String(Boolean(msg)));
          if (msg) { say(msg, false); input.focus(); return; }
          if (agree && !agree.checked) { say(d.msgConsent, false); agree.focus(); return; }
          const send = window.SAB && window.SAB.mlSubmit;
          if (typeof send !== 'function') { say(d.msgFail, false); return; }
          input.value = value;
          form.classList.add('is-busy');
          form.setAttribute('aria-busy', 'true');
          if (button) button.disabled = true;
          say('', false);
          send(form, d.action, d.hidden || '')
            .then((ok) => {
              if (ok) {
                form.classList.add('is-sent');
                say(d.msgSuccess, true);
              } else {
                say(d.msgFail, false);
                if (button) button.disabled = false;
              }
            })
            .finally(() => {
              form.classList.remove('is-busy');
              form.removeAttribute('aria-busy');
            });
        });
      }
    });
  }

  /* sab-lazy-bg · motivo di sfondo scaricato quando il riquadro è a meno di 600 px dallo schermo (definito anche in sab-h-story) */
  if (!customElements.get('sab-lazy-bg')) {
    customElements.define('sab-lazy-bg', class extends HTMLElement {
      connectedCallback() {
        if (!('IntersectionObserver' in window)) { this.classList.add('is-near'); return; }
        this._io = new IntersectionObserver((entries) => entries.forEach((e) => {
          if (e.isIntersecting) { this.classList.add('is-near'); this._io.disconnect(); }
        }), { rootMargin: '600px 0px' });
        this._io.observe(this);
      }
      disconnectedCallback() { if (this._io) this._io.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-p-main"] && !Shopify.designMode) return;
  try {
    
  /* Scheda libro v1.4 (sab-product.js del prototipo) in custom element, JS vanilla, nessuna libreria. */
  (() => {
    const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Galleria: scroll-snap nativo; pallini e miniature seguono lo scorrimento; frecce; «See inside» apre il dialog */
    class SabPdpGallery extends HTMLElement {
      #ac;
      #io;
      #current = -1;
      connectedCallback() {
        this.#ac = new AbortController();
        const { signal } = this.#ac;
        const track = this.querySelector('[data-pdp-track]');
        if (!track) return;
        const slides = [...this.querySelectorAll('[data-pdp-slide]')];
        const dots = [...this.querySelectorAll('.sab-gallery-pdp__dots span')];
        const thumbs = [...this.querySelectorAll('[data-pdp-thumb]')];
        const prev = this.querySelector('[data-pdp-prev]');
        const next = this.querySelector('[data-pdp-next]');
        const syncNav = () => {
          if (prev) prev.disabled = this.#current <= 0;
          if (next) next.disabled = this.#current >= slides.length - 1;
        };
        const mark = (i) => {
          if (i === this.#current) return;
          this.#current = i;
          for (const [n, d] of dots.entries()) d.classList.toggle('is-active', n === i);
          for (const [n, t] of thumbs.entries()) t.setAttribute('aria-current', String(n === i));
          syncNav();
        };
        const go = (n) => {
          const i = Math.max(0, Math.min(slides.length - 1, n));
          track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduced() ? 'auto' : 'smooth' });
          mark(i);
        };
        track.addEventListener('scroll', () => mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))), { passive: true, signal });
        for (const t of thumbs) t.addEventListener('click', () => go(Number(t.dataset.pdpThumb)), { signal });
        prev?.addEventListener('click', () => go(this.#current - 1), { signal });
        next?.addEventListener('click', () => go(this.#current + 1), { signal });
        mark(0);
        /* le slide fuori dalla piastra hanno l'immagine nascosta: non stanno «sopra» il testo accanto */
        if ('IntersectionObserver' in window && slides.length > 1) {
          this.#io = new IntersectionObserver((entries) => {
            for (const e of entries) e.target.toggleAttribute('data-off', !e.isIntersecting);
          }, { root: track, rootMargin: '0px -2px 0px -2px', threshold: 0 });
          for (const s of slides) this.#io.observe(s);
        }
      }
      disconnectedCallback() { this.#ac?.abort(); this.#io?.disconnect(); }
    }

    /* Acquisto: formato × store Amazon → link giusto. Una combinazione che non esiste non si sceglie. */
    const STORE_KEY = 'sab-amazon-store';
    const andList = (names) => (names.length < 2 ? names[0] : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`);
    class SabBuyBox extends HTMLElement {
      #ac;
      connectedCallback() {
        this.#ac = new AbortController();
        const { signal } = this.#ac;
        let links = [];
        try { links = JSON.parse(this.querySelector('[data-buy-links]').textContent); } catch (e) { return; }
        if (!links.length) return;
        const title = this.dataset.title || '';
        const single = this.dataset.singleFormat;
        const fmtPills = [...this.querySelectorAll('[data-format]')];
        const mktPills = [...this.querySelectorAll('[data-market]')];
        const formats = fmtPills.length ? fmtPills.map((p) => p.dataset.format) : [single || links[0].format];
        const missing = this.querySelector('[data-buy-missing]');
        const storeline = this.querySelector('[data-buy-storeline]');
        const change = this.querySelector('[data-buy-change]');
        const storeList = this.querySelector('#buy-stores');
        const has = (f, m) => links.find((l) => l.format === f && l.market === m);
        const pillOf = (m) => mktPills.find((p) => p.dataset.market === m);
        const guess = () => {
          const q = new URLSearchParams(location.search).get('market');
          if (q) return q;
          try { const saved = localStorage.getItem(STORE_KEY); if (saved) return saved; } catch (e) { /* storage bloccato */ }
          const langs = (navigator.languages || [navigator.language || 'en-US']).join(',').toLowerCase();
          if (/-gb|-uk|-ie/.test(langs)) return 'co.uk';
          if (/-ca/.test(langs)) return 'ca';
          if (/-au|-nz/.test(langs)) return 'com.au';
          return this.dataset.defaultMarket || 'com';
        };
        const ok = (m) => pillOf(m) && formats.some((f) => has(f, m));
        let market = guess();
        if (!ok(market)) market = this.dataset.defaultMarket || 'com';
        if (!ok(market)) market = 'com';
        if (!ok(market)) market = links[0].market;
        let format = formats.find((f) => has(f, market)) || formats[0];

        const render = () => {
          const mPill = pillOf(market);
          const domain = mPill ? mPill.dataset.domain : `amazon.${market}`;
          const off = formats.filter((f) => !has(f, market));
          for (const p of fmtPills) {
            const isOff = off.includes(p.dataset.format);
            p.setAttribute('aria-pressed', String(p.dataset.format === format));
            p.classList.toggle('is-off', isOff);
            if (isOff) { p.setAttribute('aria-disabled', 'true'); p.setAttribute('aria-label', `${p.dataset.format}, not on ${domain}`); }
            else { p.removeAttribute('aria-disabled'); p.removeAttribute('aria-label'); }
          }
          if (missing) {
            missing.hidden = !off.length;
            if (off.length) missing.textContent = `${andList(off)} ${off.length > 1 ? 'aren’t' : 'isn’t'} on ${domain}.`;
          }
          for (const p of mktPills) {
            p.setAttribute('aria-pressed', String(p === mPill));
            p.disabled = !formats.some((f) => has(f, p.dataset.market));
          }
          if (storeline) storeline.textContent = single ? `${single} on ${domain}` : `On ${domain}`;
          const hit = has(format, market);
          for (const a of document.querySelectorAll('[data-buy-cta]')) {
            if (hit) {
              a.href = hit.url;
              a.removeAttribute('aria-disabled'); a.removeAttribute('tabindex');
              a.setAttribute('aria-label', `See the price of ${title}, ${format}, on ${domain} (opens in a new tab)`);
            } else {
              a.removeAttribute('href'); a.removeAttribute('aria-label');
              a.setAttribute('aria-disabled', 'true'); a.setAttribute('tabindex', '-1');
            }
          }
          const row = hit || links.find((l) => l.format === format);
          const isbn = document.querySelector('[data-buy-isbn]');
          if (isbn && row && row.isbn) isbn.textContent = row.isbn;
          const kindleNote = document.querySelector('[data-kindle-note]');
          if (kindleNote) kindleNote.hidden = format !== 'Kindle';
          const barMeta = document.querySelector('[data-buybar-meta]');
          if (barMeta && mPill) barMeta.textContent = `${format} · ${mPill.dataset.short}`;
        };
        const setList = (open) => { if (!storeList) return; storeList.hidden = !open; change?.setAttribute('aria-expanded', String(open)); };
        for (const p of fmtPills) p.addEventListener('click', () => {
          if (p.getAttribute('aria-disabled') === 'true') return;
          format = p.dataset.format;
          render();
        }, { signal });
        change?.addEventListener('click', () => {
          setList(storeList.hidden);
          if (!storeList.hidden) pillOf(market)?.focus();
        }, { signal });
        for (const p of mktPills) p.addEventListener('click', () => {
          market = p.dataset.market;
          if (!has(format, market)) format = formats.find((f) => has(f, market));
          try { localStorage.setItem(STORE_KEY, market); } catch (e) { /* niente memoria */ }
          render();
          setList(false);
          change?.focus();
        }, { signal });
        storeList?.addEventListener('keydown', (e) => { if (e.key === 'Escape') { setList(false); change?.focus(); } }, { signal });
        render();
      }
      disconnectedCallback() { this.#ac?.abort(); }
    }

    /* Copia ISBN per le librerie */
    class SabIsbnCopy extends HTMLElement {
      #ac;
      connectedCallback() {
        this.#ac = new AbortController();
        const btn = this.querySelector('[data-copy-isbn]');
        if (!btn) return;
        const label = btn.textContent;
        const status = this.querySelector('[data-copy-status]');
        btn.addEventListener('click', async () => {
          const value = (this.querySelector('[data-buy-isbn]')?.textContent || '').trim();
          let ok = true;
          try { await navigator.clipboard.writeText(value); }
          catch (e) {
            try {
              const tmp = Object.assign(document.createElement('textarea'), { value });
              document.body.append(tmp); tmp.select(); ok = document.execCommand('copy'); tmp.remove();
            } catch (e2) { ok = false; }
          }
          const msg = ok ? this.dataset.done : this.dataset.fail;
          if (status) status.textContent = msg;
          if (ok) {
            btn.textContent = msg;
            btn.classList.add('is-done');
            setTimeout(() => { btn.textContent = label; btn.classList.remove('is-done'); }, 2000);
          }
        }, { signal: this.#ac.signal });
      }
      disconnectedCallback() { this.#ac?.abort(); }
    }

    /* Barra fissa: compare solo dopo che il bottone principale è uscito verso l'alto; sparisce sul footer; fuori schermo è inerte */
    class SabBuybar extends HTMLElement {
      #ac;
      #ios = [];
      connectedCallback() {
        const cta = document.querySelector('.sab-buy__cta');
        if (!cta || !('IntersectionObserver' in window)) return;
        this.#ac = new AbortController();
        this.hidden = false;
        let away = false;
        let atFooter = false;
        const sync = () => {
          const on = away && !atFooter;
          this.classList.toggle('is-on', on);
          this.toggleAttribute('inert', !on);
        };
        const check = () => { away = cta.getBoundingClientRect().bottom < 0; sync(); };
        const io = new IntersectionObserver(check);
        io.observe(cta);
        this.#ios.push(io);
        let tick = 0;
        window.addEventListener('scroll', () => { if (!tick) tick = requestAnimationFrame(() => { tick = 0; check(); }); }, { passive: true, signal: this.#ac.signal });
        const footer = document.querySelector('.sab-footer') || document.querySelector('footer');
        if (footer) {
          const fio = new IntersectionObserver(([e]) => { atFooter = e.isIntersecting; sync(); });
          fio.observe(footer);
          this.#ios.push(fio);
        }
        sync();
      }
      disconnectedCallback() { this.#ac?.abort(); for (const io of this.#ios) io.disconnect(); this.#ios = []; }
    }

    /* Dialog «See inside»: frecce, contatore, tasti ← →. Apertura, chiusura (Esc, fondo, ×) e focus di ritorno: sab-base.js
       ([data-dialog-open] / [data-dialog-close]). */
    class SabInsideDialog extends HTMLElement {
      #ac;
      #index = 0;
      connectedCallback() {
        this.#ac = new AbortController();
        const { signal } = this.#ac;
        const dialog = this.querySelector('dialog');
        if (!dialog) return;
        const slides = [...dialog.querySelectorAll('[data-slide]')];
        const count = dialog.querySelector('[data-gallery-count]');
        this.show = (n) => {
          this.#index = (n + slides.length) % slides.length;
          for (const [i, s] of slides.entries()) s.hidden = i !== this.#index;
          if (count) count.textContent = `${this.#index + 1} / ${slides.length}`;
        };
        dialog.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.show(this.#index - 1), { signal });
        dialog.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.show(this.#index + 1), { signal });
        dialog.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') this.show(this.#index + 1);
          if (e.key === 'ArrowLeft') this.show(this.#index - 1);
        }, { signal });
        this.show(0);
      }
      disconnectedCallback() { this.#ac?.abort(); }
    }

    const define = (name, cls) => { if (!customElements.get(name)) customElements.define(name, cls); };
    define('sab-pdp-gallery', SabPdpGallery);
    define('sab-buy-box', SabBuyBox);
    define('sab-isbn-copy', SabIsbnCopy);
    define('sab-buybar', SabBuybar);
    define('sab-inside-dialog', SabInsideDialog);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-p-related"] && !Shopify.designMode) return;
  try {
    
  /* Fila «You may also like»: frecce che scorrono di una card; nascoste se non c'è niente da scorrere */
  (() => {
    class SabPdpRail extends HTMLElement {
      #ac;
      #ro;
      connectedCallback() {
        const track = this.querySelector('[data-rail-track]');
        const arrows = this.querySelector('[data-rail-arrows]');
        const prev = this.querySelector('[data-rail-prev]');
        const next = this.querySelector('[data-rail-next]');
        if (!track || !arrows || !prev || !next) return;
        this.#ac = new AbortController();
        const { signal } = this.#ac;
        const step = () => (track.firstElementChild?.getBoundingClientRect().width || 240) + 16;
        const update = () => {
          arrows.hidden = track.scrollWidth <= track.clientWidth + 2;
          prev.disabled = track.scrollLeft < 8;
          next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8;
        };
        prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }), { signal });
        next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }), { signal });
        track.addEventListener('scroll', update, { passive: true, signal });
        if ('ResizeObserver' in window) {
          this.#ro = new ResizeObserver(update);
          this.#ro.observe(track);
        }
        update();
      }
      disconnectedCallback() { this.#ac?.abort(); this.#ro?.disconnect(); }
    }
    if (!customElements.get('sab-pdp-rail')) customElements.define('sab-pdp-rail', SabPdpRail);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-x-about-book"] && !Shopify.designMode) return;
  try {
    
/* About v2 · «Our story, read it like a book» (giro 2, 18/10/2026). Un libro che si sfoglia davvero: ogni foglio gira
   sul dorso (rotateY). Due libri nello stesso markup, uno per desktop (libro aperto, due pagine) e uno per telefono
   (una pagina alla volta); il CSS ne mostra uno, il JS li tiene allo stesso capitolo.
   Comandi: tocco o clic a destra = avanti, a sinistra = indietro; «Next chapter» e «Previous»; linguette dei capitoli
   (sfoglia una pagina dopo l'altra); frecce della tastiera; swipe. Ogni capitolo aperto diventa «letto». */
(() => {
  const root = document.querySelector('[data-ab2-story]');
  if (!root) return;
  const books = [...root.querySelectorAll('[data-fb]')];
  const tabs = [...root.querySelectorAll('[data-go]')];
  const prev = root.querySelector('[data-prev]');
  const next = root.querySelector('[data-next]');
  const count = root.querySelector('[data-count]');
  const done = root.querySelector('[data-done]');
  const live = root.querySelector('[data-live]');
  const total = tabs.length;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const read = new Set();
  const TURN = 900;
  let index = 0;
  let queue = Promise.resolve();
  /* copertina (show_cover): il libro parte chiuso; «avanti» lo apre sul capitolo 1, «indietro» dal capitolo 1 lo richiude */
  const covers = books.map((b) => b.querySelector('[data-cover]')).filter(Boolean);
  let closed = covers.length > 0;
  const nextLabel = next.querySelector('span');
  const nextText = nextLabel ? nextLabel.textContent : '';
  const openText = root.dataset.openWord || nextText;
  /* durata vera della girata (sul telefono è più lenta): il CSS comanda, il JS la legge */
  const duration = (el) => {
    const d = parseFloat(getComputedStyle(el).transitionDuration);
    return Number.isFinite(d) && d > 0 ? d * 1000 : TURN;
  };

  /* z-index dei fogli: quelli da girare impilati a destra (il primo sopra), quelli girati a sinistra (l'ultimo sopra) */
  const stack = (book) => {
    const leaves = [...book.querySelectorAll('[data-leaf]')];
    leaves.forEach((leaf, k) => {
      if (leaf.classList.contains('is-turning')) return;
      leaf.style.zIndex = String(leaf.classList.contains('is-flipped') ? 10 + k : 10 + (leaves.length - k));
    });
  };
  /* le facce non visibili non si leggono e non si toccano con la tastiera */
  const hideFaces = (book) => {
    const leaves = [...book.querySelectorAll('[data-leaf]')];
    const n = leaves.length;
    const visible = new Set();
    if (closed) {
      visible.add('cover');
    } else if (book.dataset.fb === 'spread') {
      /* a sinistra: retro del foglio index-1 (o base sinistra), a destra: fronte del foglio index (o base destra) */
      visible.add(index === 0 ? 'base-l' : `back-${index - 1}`);
      visible.add(index >= n ? 'base-r' : `front-${index}`);
    } else {
      visible.add(index >= n ? 'base' : `front-${index}`);
    }
    book.querySelectorAll('[data-face]').forEach((face) => {
      const on = visible.has(face.dataset.face);
      face.setAttribute('aria-hidden', String(!on));
      face.inert = !on;
    });
  };
  const turnLeaf = (book, k, flip) =>
    new Promise((resolve) => {
      const leaf = book.querySelector(`[data-leaf="${k}"]`);
      if (!leaf || leaf.classList.contains('is-flipped') === flip) { resolve(); return; }
      leaf.classList.add('is-turning');
      leaf.style.zIndex = '50';
      leaf.classList.toggle('is-flipped', flip);
      const end = () => { leaf.classList.remove('is-turning'); stack(book); resolve(); };
      if (reduce.matches || !book.offsetParent) end();
      else setTimeout(end, duration(leaf));
    });

  /* gira la copertina: open = true la apre (va a sinistra sul dorso), false la richiude */
  const turnCover = (open) =>
    new Promise((resolve) => {
      if (!covers.length) { resolve(); return; }
      closed = !open;
      covers.forEach((c) => {
        c.classList.remove('is-gone');
        void c.offsetWidth;
        c.classList.add('is-turning');
        c.classList.toggle('is-open', open);
      });
      books.forEach((b) => { b.classList.toggle('is-closed', !open); b.classList.toggle('is-opening', open); });
      paint();
      const wait = reduce.matches ? 0 : Math.max(...covers.map((c) => (c.closest('[data-fb]').offsetParent ? duration(c) : 0)));
      setTimeout(() => {
        books.forEach((b) => b.classList.remove('is-opening'));
        covers.forEach((c) => { c.classList.remove('is-turning'); if (open) c.classList.add('is-gone'); });
        paint();
        resolve();
      }, wait);
    });

  const paint = () => {
    read.add(index);
    tabs.forEach((t, k) => {
      t.setAttribute('aria-current', String(k === index));
      t.classList.toggle('is-read', read.has(k));
    });
    const bar = tabs[index] && tabs[index].closest('.ab2-tabs');
    if (bar && bar.scrollWidth > bar.clientWidth) {
      const li = tabs[index].parentElement;
      bar.scrollTo({ left: li.offsetLeft - (bar.clientWidth - li.offsetWidth) / 2, behavior: reduce.matches ? 'auto' : 'smooth' });
    }
    root.classList.toggle('is-closed', closed);
    prev.disabled = closed || (index === 0 && !covers.length);
    next.disabled = !closed && index === total - 1;
    if (nextLabel) nextLabel.textContent = closed ? openText : nextText;
    count.textContent = String(index + 1);
    if (live) live.textContent = tabs[index] ? `${root.dataset.chapterWord || 'Chapter'} ${index + 1} ${root.dataset.ofWord || 'of'} ${total}: ${tabs[index].dataset.title || ''}` : '';
    if (read.size === total) done.hidden = false;
    books.forEach(hideFaces);
  };

  /* va al capitolo n girando i fogli uno alla volta (le linguette sfogliano tutte le pagine in mezzo) */
  const go = (n) => {
    const target = Math.max(0, Math.min(total - 1, n));
    queue = queue.then(async () => {
      if (closed) await turnCover(true);
      while (index !== target) {
        const forward = target > index;
        const k = forward ? index : index - 1;
        index += forward ? 1 : -1;
        paint();
        await Promise.all(books.map((b) => turnLeaf(b, k, forward)));
        if (index !== target) await new Promise((r) => setTimeout(r, 60));
      }
    });
  };

  /* un passo avanti o indietro: a libro chiuso «avanti» lo apre; dal capitolo 1 «indietro» lo richiude */
  const step = (d) => {
    if (closed) { if (d > 0) go(0); return; }
    if (d < 0 && index === 0 && covers.length) { queue = queue.then(() => turnCover(false)); return; }
    go(index + d);
  };

  tabs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.go))));
  prev.addEventListener('click', () => step(-1));
  next.addEventListener('click', () => step(1));
  root.querySelectorAll('[data-open]').forEach((b) => b.addEventListener('click', () => step(1)));
  root.addEventListener('keydown', (e) => {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    if (e.target.closest('input, textarea, select')) return;
    e.preventDefault();
    step(e.key === 'ArrowRight' ? 1 : -1);
  });

  /* tocco e swipe sul libro: destra/avanti, sinistra/indietro (i link dentro le pagine restano link) */
  books.forEach((book) => {
    let x0 = null;
    let y0 = 0;
    let swiped = false;
    book.addEventListener('pointerdown', (e) => { x0 = e.clientX; y0 = e.clientY; swiped = false; }, { passive: true });
    book.addEventListener('pointerup', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0;
      const dy = e.clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) {
        swiped = true;
        step(dx < 0 ? 1 : -1);
      }
    });
    book.addEventListener('pointercancel', () => { x0 = null; });
    book.addEventListener('click', (e) => {
      if (swiped) { swiped = false; return; }
      if (e.target.closest('a, button')) return;
      const r = book.getBoundingClientRect();
      const left = e.clientX - r.left < r.width * (book.dataset.fb === 'spread' ? 0.5 : 0.35);
      step(closed || !left ? 1 : -1);
    });
  });

  books.forEach(stack);
  paint();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-x-about-chapters"] && !Shopify.designMode) return;
  try {
    
  /* About · chapters (port of sab-about.js): cards with aria-pressed, counter in role="status",
     «Flip all» without aria-pressed (state in data-state, the label changes). */
  if (!customElements.get('sab-x-info-chapters')) {
    class SabXInfoChapters extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        else this.init();
      }
      init() {
        if (this._ready) return;
        this._ready = true;
        this.cards = [...this.querySelectorAll('[data-chapter]')];
        this.all = this.querySelector('[data-flip-all]');
        this.count = this.querySelector('[data-chapters-count]');
        this.progress = this.querySelector('[data-chapters-progress]');
        this.done = this.querySelector('[data-chapters-done]');
        this.dots = [...this.querySelectorAll('.sab-about-chapters__dots i')];
        this.cards.forEach((card) => card.addEventListener('click', () => {
          card.setAttribute('aria-pressed', String(!this.isOn(card)));
          this.sync();
        }));
        if (this.all) {
          this.all.addEventListener('click', () => {
            const flip = this.all.dataset.state !== 'on';
            const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            this.cards.forEach((card, i) => {
              window.setTimeout(() => { card.setAttribute('aria-pressed', String(flip)); this.sync(); }, still ? 0 : i * 110);
            });
          });
        }
        this.sync();
      }
      isOn(card) { return card.getAttribute('aria-pressed') === 'true'; }
      sync() {
        const n = this.cards.filter((card) => this.isOn(card)).length;
        if (this.count) this.count.textContent = String(n);
        this.dots.forEach((dot, i) => dot.classList.toggle('is-on', i < n));
        const complete = this.cards.length > 0 && n === this.cards.length;
        if (this.progress) this.progress.hidden = complete;
        if (this.done) this.done.hidden = !complete;
        if (this.all) this.all.dataset.state = complete ? 'on' : 'off';
      }
    }
    customElements.define('sab-x-info-chapters', SabXInfoChapters);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-x-about-readers"] && !Shopify.designMode) return;
  try {
    
  /* Horizontal rail (port of the [data-sab-rail] block of sab-common.js): the arrows scroll by one card. */
  if (!customElements.get('sab-x-info-rail')) {
    class SabXInfoRail extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        else this.init();
      }
      init() {
        if (this._ready) return;
        this._ready = true;
        const track = this.querySelector('[data-rail-track]');
        const prev = this.querySelector('[data-rail-prev]');
        const next = this.querySelector('[data-rail-next]');
        if (!track || !prev || !next) return;
        const step = () => (track.querySelector(':scope > *')?.getBoundingClientRect().width || 240) + 16;
        const update = () => {
          prev.disabled = track.scrollLeft < 8;
          next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8;
        };
        prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
        next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }
    }
    customElements.define('sab-x-info-rail', SabXInfoRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-x-contact"] && !Shopify.designMode) return;
  try {
    
  /* Contact · form (port of sab-form.js without the prototype preventDefault): browser checks with a summary role="alert",
     then the native Shopify contact form posts. Same component as Rights & Partners (sab-x-info-form). */
  if (!customElements.get('sab-x-info-form')) {
    const SAB_X_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const SAB_X_T = {
      required: 'Please fill in this field.',
      select: 'Please choose an option.',
      email: 'That email doesn’t look right. Please check it and try again.',
      consent: 'Please tick the box so we can reply to you.',
      summary: 'Please check these fields:'
    };
    const SAB_X_KEY = 'sab-x-info-last-form';
    class SabXInfoForm extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        else this.init();
      }
      init() {
        if (this._ready) return;
        this.form = this.querySelector('form');
        if (!this.form) return;
        this._ready = true;
        this.form.noValidate = true;
        this.summary = this.querySelector('[data-form-summary]');
        this.fields = [...this.form.querySelectorAll('input:not([type="hidden"]), select, textarea')].filter((f) => f.required);
        this.tried = false;
        this.fields.forEach((f) => {
          f.addEventListener(f.type === 'checkbox' || f.tagName === 'SELECT' ? 'change' : 'blur', () => { if (this.tried) this.check(f); });
        });
        this.form.addEventListener('submit', (event) => this.onSubmit(event));
        if (this.summary) {
          this.summary.addEventListener('click', (event) => {
            const a = event.target.closest('a[href^="#"]');
            if (!a) return;
            event.preventDefault();
            document.getElementById(a.getAttribute('href').slice(1))?.focus();
          });
        }
        this.querySelectorAll('select[data-topic-hint]').forEach((select) => {
          const hint = document.getElementById(select.dataset.topicHint);
          const update = () => { if (hint) hint.hidden = select.value !== hint.dataset.whenValue; };
          select.addEventListener('change', update);
          update();
        });
        this.markPosted();
      }
      labelOf(f) {
        if (f.dataset.summary) return f.dataset.summary;
        const l = this.form.querySelector(`label[for="${f.id}"]`);
        return (l ? l.textContent.trim().replace(/\s*\(.*\)$/, '') : '') || f.name;
      }
      check(f) {
        let msg = '';
        if (f.type === 'checkbox') { if (!f.checked) msg = SAB_X_T.consent; }
        else if (!f.value.trim()) msg = f.tagName === 'SELECT' ? SAB_X_T.select : SAB_X_T.required;
        else if (f.type === 'email' && !SAB_X_EMAIL.test(f.value.trim())) msg = SAB_X_T.email;
        const wrap = f.closest('.sab-field');
        const err = document.getElementById(`${f.id}-err`);
        if (wrap) wrap.classList.toggle('is-invalid', Boolean(msg));
        f.setAttribute('aria-invalid', String(Boolean(msg)));
        if (err) { err.textContent = msg; err.hidden = !msg; }
        const ids = (f.getAttribute('aria-describedby') || '').split(' ').filter((x) => x && x !== `${f.id}-err`);
        if (msg) ids.push(`${f.id}-err`);
        if (ids.length) f.setAttribute('aria-describedby', ids.join(' ')); else f.removeAttribute('aria-describedby');
        return msg;
      }
      onSubmit(event) {
        if (this.go) return;
        this.tried = true;
        const bad = this.fields.filter((f) => this.check(f));
        if (bad.length) {
          event.preventDefault();
          if (this.summary) {
            const items = bad.map((f) => `<li><a href="#${f.id}">${this.labelOf(f)}</a></li>`).join('');
            this.summary.innerHTML = `<p>${SAB_X_T.summary}</p><ul>${items}</ul>`;
            this.summary.hidden = false;
            this.summary.focus();
          } else bad[0].focus();
          return;
        }
        if (this.summary) this.summary.hidden = true;
        try { window.sessionStorage.setItem(SAB_X_KEY, this.form.id); } catch (e) { /* storage off */ }
        const action = (this.dataset.mlAction || '').trim();
        if (!action) return;
        event.preventDefault();
        this.classList.add('is-busy');
        const data = new FormData();
        this.form.querySelectorAll('[data-ml]').forEach((f) => { if (f.value.trim()) data.append(`fields[${f.dataset.ml}]`, f.value.trim()); });
        data.append('ml-submit', '1');
        data.append('anticsrf', 'true');
        const ctrl = 'AbortController' in window ? new AbortController() : null;
        const timer = window.setTimeout(() => { if (ctrl) ctrl.abort(); }, 6000);
        const submitter = event.submitter && event.submitter.form === this.form ? event.submitter : undefined;
        fetch(action, { method: 'POST', body: data, mode: 'no-cors', signal: ctrl ? ctrl.signal : undefined })
          .catch(() => {})
          .finally(() => {
            window.clearTimeout(timer);
            this.go = true;
            if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit(submitter);
            else this.form.submit();
          });
      }
      markPosted() {
        if (!this.querySelector('[data-form-state]')) return;
        const posted = [...document.querySelectorAll('sab-x-info-form')].filter((el) => el.querySelector('form') && el.querySelector('[data-form-state]'));
        const ids = posted.map((el) => el.querySelector('form').id);
        const hash = decodeURIComponent(window.location.hash.slice(1));
        let last = null;
        try { last = window.sessionStorage.getItem(SAB_X_KEY); } catch (e) { /* storage off */ }
        let current = null;
        if (ids.includes(hash)) current = hash;
        else if (last && ids.includes(last)) current = last;
        else {
          const primary = posted.find((el) => el.hasAttribute('data-primary')) || posted[0];
          current = primary ? primary.querySelector('form').id : null;
        }
        if (current !== this.form.id) return;
        this.classList.add('is-current');
        const panel = this.closest('[data-catalog-panel]');
        if (panel) panel.classList.add('is-open');
        const msg = this.querySelector('.sab-x-msg');
        if (msg) window.requestAnimationFrame(() => { msg.focus(); msg.scrollIntoView({ block: 'center' }); });
      }
    }
    customElements.define('sab-x-info-form', SabXInfoForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-x-contest-fx"]) return;
  try {
    
  /* sab-x-contest-fx · moves the peeking characters into their sections, adds bats, stars and the reveal */
  if (!customElements.get('sab-contest-fx')) {
    customElements.define(
      'sab-contest-fx',
      class extends HTMLElement {
        connectedCallback() {
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          /* the boxes the characters sit on (18/10: the box itself, not the section, so the feet rest on its border) */
          const targets = {
            steps: '.sab-contest-steps .sab-gift-steps__box',
            books: '.sab-contest-books',
            prizes: '.sab-contest-prizes__box',
            judge: '.sab-contest-meet__card',
            faq: '.sab-faq',
            rules: '.sab-contest-rules__box',
            join: '.sab-contest-join__box',
          };
          const watch = [];
          const peeks = [];
          this.querySelectorAll('.sab-peek').forEach((img) => {
            const host = document.querySelector(targets[img.dataset.target] || '');
            if (!host) {
              img.remove();
              return;
            }
            img.setAttribute('aria-hidden', 'true');
            host.classList.add('sab-has-peek');
            host.appendChild(img);
            watch.push(img);
            peeks.push({ img, host });
          });
          if (!reduce) document.documentElement.classList.add('sab-fx-on');

          /* room above each box: if the gap to the content above is shorter than the character, add top margin */
          const docTop = (el) => {
            let y = 0;
            for (let n = el; n; n = n.offsetParent) y += n.offsetTop;
            return y;
          };
          const fit = () => {
            peeks.forEach(({ img, host }) => {
              host.style.marginBlockStart = '';
              if (!img.offsetHeight) return;
              const over = -img.offsetTop;   /* how far the character sticks out above the box */
              if (over <= 0) return;
              let prev = host.closest('.shopify-section')?.previousElementSibling;
              while (prev && prev.offsetHeight < 2) prev = prev.previousElementSibling;
              if (!prev) return;
              const gap = docTop(host) - (docTop(prev) + prev.offsetHeight);
              const need = over + 12;
              if (gap < need) {
                const base = parseFloat(getComputedStyle(host).marginBlockStart) || 0;
                host.style.marginBlockStart = `${Math.ceil(base + need - gap)}px`;
              }
            });
          };
          fit();
          window.addEventListener('load', fit, { once: true });
          let fitTimer;
          window.addEventListener('resize', () => {
            clearTimeout(fitTimer);
            fitTimer = setTimeout(fit, 150);
          });

          /* sticky «Join free»: only below the sign-up box, never over it, never after signing up */
          const sticky = this.querySelector('[data-sticky]');
          const signup = document.getElementById('sign-up');
          if (sticky && signup && 'IntersectionObserver' in window) {
            const v = new URLSearchParams(location.search).get('sticky');
            if (v && /^[0-5]$/.test(v)) sticky.dataset.v = v;
            const cd = document.querySelector('[data-countdown]');
            const end = cd ? Date.parse(cd.getAttribute('data-countdown') || '') : NaN;
            const tickSticky = () => {
              const left = end - Date.now();
              if (!(left > 0)) return;
              sticky.querySelector('[data-scd="d"]').textContent = Math.floor(left / 86400000);
              sticky.querySelector('[data-scd="h"]').textContent = Math.floor((left % 86400000) / 3600000);
              sticky.querySelector('[data-scd="m"]').textContent = Math.floor((left % 3600000) / 60000);
            };
            if (!Number.isNaN(end)) {
              tickSticky();
              setInterval(tickSticky, 30000);
            }
            document.body.appendChild(sticky);
            const signed = () => {
              try {
                return !!JSON.parse(localStorage.getItem('sabContest26') || '{}').signed;
              } catch (e) {
                return false;
              }
            };
            if (signup.querySelector('[data-posted]')) {
              sticky.remove();
            } else {
              /* 18/10 QA: hidden also over the footer, where it covered the last link («Back to top») on phones */
              let below = false;
              let atFoot = false;
              const sync = () => { sticky.hidden = !below || atFoot || signed(); };
              new IntersectionObserver(([entry]) => {
                below = !entry.isIntersecting && entry.boundingClientRect.top < 0;
                sync();
              }).observe(signup);
              const foot = document.querySelector('.sab-footer');
              if (foot) new IntersectionObserver(([entry]) => { atFoot = entry.isIntersecting; sync(); }).observe(foot);
            }
          }

          const plate = document.querySelector('.sab-contest-hero3, .sab-contest-signup__plate');
          if (plate && !reduce) {
            if (this.hasAttribute('data-bats')) {
              const bat = '<svg viewBox="0 0 64 32" aria-hidden="true"><path fill="currentColor" d="M32 10c2-4 3-6 3-6s1 3 0 6c4-2 9-4 14-3 4 1 9 4 13 9-5-1-9 0-12 3-2-2-6-3-9-1-2-3-5-4-9-3-4-1-7 0-9 3-3-2-7-1-9 1-3-3-7-4-12-3 4-5 9-8 13-9 5-1 10 1 14 3-1-3 0-6 0-6s1 2 3 6z"/></svg>';
              [
                ['18%', '0s', '11s'],
                ['8%', '4s', '13s'],
                ['30%', '8s', '12s'],
              ].forEach(([top, delay, dur]) => {
                const el = document.createElement('span');
                el.className = 'sab-fx-bat';
                el.innerHTML = bat;
                el.style.top = top;
                el.style.left = '0';
                el.style.setProperty('--delay', delay);
                el.style.setProperty('--dur', dur);
                plate.appendChild(el);
              });
            }
            if (this.hasAttribute('data-stars')) {
              const star = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 0C13 8 16 11 24 12C16 13 13 16 12 24C11 16 8 13 0 12C8 11 11 8 12 0Z"/></svg>';
              [
                ['6%', '58%', '0s'],
                ['14%', '88%', '0.7s'],
                ['40%', '94%', '1.4s'],
                ['3%', '35%', '2.1s'],
                ['52%', '4%', '0.4s'],
                ['26%', '70%', '1.8s'],
              ].forEach(([top, left, delay]) => {
                const el = document.createElement('span');
                el.className = 'sab-fx-star';
                el.innerHTML = star;
                el.style.top = top;
                el.style.left = left;
                el.style.setProperty('--delay', delay);
                plate.appendChild(el);
              });
            }
          }

          if (this.hasAttribute('data-reveal') && !reduce) {
            document
              .querySelectorAll('.sab-contest-steps, .sab-contest-books, .sab-contest-prizes, .sab-contest-judge, .sab-contest-meet__card, .sab-contest-cards, .sab-faq, .sab-contest-rules, .sab-contest-join')
              .forEach((el) => {
                el.classList.add('sab-fx-reveal');
                watch.push(el);
              });
          }
          if (!('IntersectionObserver' in window)) {
            watch.forEach((el) => el.classList.add('is-in'));
            return;
          }
          this.io = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-in');
                this.io.unobserve(entry.target);
              });
            },
            { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
          );
          watch.forEach((el) => this.io.observe(el));
        }

        disconnectedCallback() {
          this.io?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-x-contest-meet"]) return;
  try {
    
  /* sab-x-contest-meet · color reveal: drag on the page or use the slider; a short demo sweep on first view */
  if (!customElements.get('sab-contest-meet')) {
    customElements.define(
      'sab-contest-meet',
      class extends HTMLElement {
        connectedCallback() {
          this.ac = new AbortController();
          const { signal } = this.ac;
          this.initCards(signal);
          const box = this.querySelector('[data-reveal-box]');
          if (!box) return;
          const stage = box.querySelector('.sab-contest-meet__stage');
          const range = box.querySelector('[data-reveal-range]');
          const set = (v) => {
            const val = Math.max(0, Math.min(100, v));
            stage.style.setProperty('--cut', `${val}%`);
            if (range) range.value = String(Math.round(val));
          };
          range?.addEventListener('input', () => set(Number(range.value)), { signal });
          let dragging = false;
          const fromEvent = (e) => {
            const r = stage.getBoundingClientRect();
            set(((e.clientX - r.left) / r.width) * 100);
          };
          stage.addEventListener('pointerdown', (e) => { dragging = true; stage.setPointerCapture?.(e.pointerId); fromEvent(e); }, { signal });
          stage.addEventListener('pointermove', (e) => { if (dragging) fromEvent(e); }, { signal });
          stage.addEventListener('pointerup', () => { dragging = false; }, { signal });
          stage.addEventListener('pointercancel', () => { dragging = false; }, { signal });
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (reduce || !('IntersectionObserver' in window)) return;
          this.io = new IntersectionObserver(
            ([entry]) => {
              if (!entry.isIntersecting) return;
              this.io.disconnect();
              const start = performance.now();
              const sweep = (now) => {
                if (dragging) return;
                const t = Math.min(1, (now - start) / 2200);
                const v = t < 0.5 ? 50 + 45 * Math.sin(t * 2 * Math.PI) : 50 - 45 * Math.sin((t - 0.5) * 2 * Math.PI);
                set(v);
                if (t < 1) requestAnimationFrame(sweep);
              };
              requestAnimationFrame(sweep);
            },
            { threshold: 0.6 }
          );
          this.io.observe(stage);
        }

        initCards(signal) {
          const game = this.querySelector('[data-cards]');
          if (!game) return;
          const cards = [...game.querySelectorAll('[data-card]')];
          const count = game.querySelector('[data-cards-count]');
          const win = game.querySelector('[data-cards-win]');
          const confetti = game.querySelector('[data-cards-confetti]');
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          let celebrated = false;
          const update = () => {
            const n = cards.filter((c) => c.getAttribute('aria-pressed') === 'true').length;
            if (count) count.textContent = String(n);
            if (n === cards.length && !celebrated) {
              celebrated = true;
              if (win) win.hidden = false;
              if (confetti && !reduce) {
                const colors = ['#FF2929', '#FFDA3E', '#5BC14F', '#44C1F2', '#D792FF', '#FF8A3D'];
                for (let i = 0; i < 28; i += 1) {
                  const p = document.createElement('i');
                  p.style.left = `${10 + Math.random() * 80}%`;
                  p.style.background = colors[i % colors.length];
                  p.style.setProperty('--x', `${(Math.random() - 0.5) * 16}rem`);
                  p.style.setProperty('--y', `${-6 - Math.random() * 10}rem`);
                  p.style.setProperty('--r', `${180 + Math.random() * 540}deg`);
                  p.style.setProperty('--t', `${1 + Math.random() * 0.8}s`);
                  confetti.appendChild(p);
                }
                setTimeout(() => confetti.replaceChildren(), 2200);
              }
            }
          };
          cards.forEach((card) => {
            card.addEventListener(
              'click',
              () => {
                card.setAttribute('aria-pressed', card.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
                update();
              },
              { signal }
            );
          });
        }

        disconnectedCallback() {
          this.ac?.abort();
          this.io?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-x-contest-signup"]) return;
  try {
    
  /* sab-x-contest-signup · MailerLite: «done» only with { success: true } (SAB.mlSubmit, JSONP).
     Shopify fallback: the native contact form posts and reloads; here only the checks and the opt-in value. */
  if (!customElements.get('sab-contest-signup')) {
    customElements.define(
      'sab-contest-signup',
      class extends HTMLElement {
        connectedCallback() {
          this.ac = new AbortController();
          const { signal } = this.ac;
          const KEY = 'sabContest26';
          const read = () => {
            try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; }
          };
          const save = (patch) => {
            try { localStorage.setItem(KEY, JSON.stringify({ ...read(), ...patch })); } catch (e) { /* private mode */ }
          };
          const mark = () => {
            const state = read();
            [['1', state.signed], ['3', state.shared]].forEach(([n, on]) => {
              const li = this.querySelector(`[data-step="${n}"]`);
              if (!li || !on) return;
              li.setAttribute('data-done', '');
              li.querySelector('[data-step-done]')?.removeAttribute('hidden');
            });
          };
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const burst = () => {
            const box = this.querySelector('[data-confetti]');
            if (!box || reduce) return;
            const colors = ['#FF2929', '#FFDA3E', '#5BC14F', '#44C1F2', '#D792FF', '#FF8A3D'];
            for (let i = 0; i < 36; i += 1) {
              const piece = document.createElement('i');
              piece.style.left = `${Math.random() * 100}%`;
              piece.style.background = colors[i % colors.length];
              piece.style.setProperty('--x', `${(Math.random() - 0.5) * 30}vw`);
              piece.style.setProperty('--r', `${360 + Math.random() * 540}deg`);
              piece.style.setProperty('--t', `${1.4 + Math.random() * 1.2}s`);
              piece.style.animationDelay = `${Math.random() * 0.3}s`;
              box.appendChild(piece);
            }
            setTimeout(() => box.replaceChildren(), 3200);
          };
          this.celebrate = () => {
            save({ signed: true });
            mark();
            burst();
          };
          mark();
          this.querySelectorAll('.sab-contest-share__btn, .sab-contest-share__ig, .sab-contest-icon').forEach((el) => {
            el.addEventListener('click', () => { save({ shared: true }); mark(); }, { signal });
          });
          /* icon row: Instagram/TikTok open the system share sheet on phones, otherwise copy the link and say where to paste it */
          const shareSay = (el, text) => {
            const msg = el.closest('[data-share-box]')?.querySelector('[data-share-msg]');
            if (!msg) return;
            msg.textContent = text;
            msg.hidden = false;
            clearTimeout(msg._t);
            msg._t = setTimeout(() => { msg.hidden = true; }, 5000);
          };
          const shareCopy = async (url) => {
            try {
              await navigator.clipboard.writeText(url);
              return true;
            } catch (e) {
              return false;
            }
          };
          this.querySelectorAll('[data-native-share]').forEach((btn) => {
            btn.addEventListener(
              'click',
              async () => {
                const url = btn.dataset.url || location.href;
                if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
                  try {
                    await navigator.share({ title: document.title, text: btn.dataset.text || '', url });
                    return;
                  } catch (e) {
                    if (e && e.name === 'AbortError') return;
                  }
                }
                shareSay(btn, (await shareCopy(url)) ? btn.dataset.copiedMsg || '' : url);
              },
              { signal }
            );
          });
          this.querySelectorAll('[data-copy-icon]').forEach((btn) => {
            btn.addEventListener(
              'click',
              async () => {
                const url = btn.dataset.url || location.href;
                shareSay(btn, (await shareCopy(url)) ? btn.dataset.copiedMsg || '' : url);
              },
              { signal }
            );
          });
          const cd = this.querySelector('[data-countdown]');
          if (cd) {
            const end = Date.parse(cd.getAttribute('data-countdown') || '');
            const start = Date.parse(cd.getAttribute('data-start') || '');
            const sr = cd.querySelector('[data-cd-sr]');
            const labelEl = cd.querySelector('.sab-contest-countdown__label');
            const tick = () => {
              const now = Date.now();
              const before = start > now;
              const left = (before ? start : end) - now;
              if (labelEl) labelEl.textContent = before ? cd.dataset.startLabel || '' : cd.dataset.label || '';
              cd.toggleAttribute('data-before', before);
              if (!(left > 0)) {
                cd.querySelector('.sab-contest-countdown__clock')?.setAttribute('hidden', '');
                const label = cd.querySelector('.sab-contest-countdown__label');
                if (label) label.textContent = cd.dataset.closed || '';
                return false;
              }
              const d = Math.floor(left / 86400000);
              const h = Math.floor((left % 86400000) / 3600000);
              const m = Math.floor((left % 3600000) / 60000);
              cd.querySelector('[data-cd="d"]').textContent = d;
              cd.querySelector('[data-cd="h"]').textContent = h;
              cd.querySelector('[data-cd="m"]').textContent = m;
              if (sr) sr.textContent = before ? `The contest opens in ${d} days, ${h} hours and ${m} minutes.` : `${d} days, ${h} hours and ${m} minutes left to enter.`;
              return true;
            };
            if (!Number.isNaN(end)) {
              cd.hidden = false;
              if (tick()) {
                const id = setInterval(() => { if (!tick()) clearInterval(id); }, 30000);
                signal.addEventListener('abort', () => clearInterval(id));
              }
            }
          }
          this.querySelectorAll('[data-copy-link]').forEach((btn) => {
            btn.addEventListener(
              'click',
              async () => {
                const url = btn.getAttribute('data-copy-link') || location.href;
                try {
                  await navigator.clipboard.writeText(url);
                  const label = btn.textContent;
                  btn.textContent = btn.dataset.copied || 'Copied';
                  setTimeout(() => (btn.textContent = label), 2000);
                } catch (e) {
                  window.prompt('Copy this link:', url);
                }
              },
              { signal }
            );
          });
          const confirmedBox = this.querySelector('[data-confirmed]');
          if (confirmedBox && new URLSearchParams(location.search).get('confirmed') === '1') {
            this.querySelectorAll('.sab-contest-hero3__form > form, .sab-contest-signup__form > form').forEach((f) => { f.hidden = true; });
            confirmedBox.hidden = false;
            save({ signed: true });
            mark();
            requestAnimationFrame(() => confirmedBox.focus({ preventScroll: true }));
            this.celebrate();
            return;
          }
          const posted = this.querySelector('[data-posted]');
          if (posted) {
            posted.focus();
            this.celebrate();
            return;
          }
          const form = this.querySelector('form[data-contest-form]');
          if (!form) return;
          const mode = form.dataset.contestForm;
          const input = form.querySelector('input[type="email"]');
          const error = form.querySelector('[data-form-error]');
          const fields = form.querySelector('[data-form-fields]');
          const done = form.querySelector('[data-form-done]');
          const button = form.querySelector('button[type="submit"]');
          if (!input || !error || !button) return;
          const say = (text) => {
            error.textContent = text || '';
            error.hidden = !text;
          };
          form.addEventListener(
            'submit',
            async (event) => {
              const value = input.value.trim();
              const key = !value ? 'empty' : /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value) ? '' : 'invalid';
              input.setAttribute('aria-invalid', String(Boolean(key)));
              if (key) {
                event.preventDefault();
                say(form.dataset[key === 'empty' ? 'msgEmpty' : 'msgInvalid']);
                input.focus();
                return;
              }
              say('');
              input.value = value;
              const box = form.querySelector('[data-optin-box]');
              const optin = form.querySelector('[data-optin-value]');
              if (box && optin) optin.value = box.checked ? 'yes' : 'no';
              if (mode !== 'ml') return; /* Shopify contact form: normal post */
              event.preventDefault();
              const trap = form.querySelector('[name="sab_hp"]');
              const showDone = () => {
                if (fields && done) {
                  fields.hidden = true;
                  done.hidden = false;
                  done.focus();
                }
                this.celebrate();
              };
              if (trap && trap.value) {
                showDone();
                return;
              }
              const send = window.SAB && window.SAB.mlSubmit;
              const action = form.getAttribute('action');
              if (!action || typeof send !== 'function') {
                say(form.dataset.msgFail);
                return;
              }
              button.disabled = true;
              button.setAttribute('aria-busy', 'true');
              /* SAB.mlSubmit manda solo i campi fields[…]: la casella del consenso (gdpr[] = Email nel Classic) va
                 aggiunta a parte, e solo se è spuntata */
              const extra = new URLSearchParams();
              const optBox = form.querySelector('[data-optin-box]');
              if (optBox && optBox.checked && optBox.name && !optBox.name.startsWith('fields[')) extra.append(optBox.name, optBox.value);
              const ok = await send(form, action, extra);
              button.disabled = false;
              button.removeAttribute('aria-busy');
              if (ok) showDone();
              else say(form.dataset.msgFail);
            },
            { signal }
          );
          input.addEventListener(
            'input',
            () => {
              if (input.getAttribute('aria-invalid') === 'true') {
                input.removeAttribute('aria-invalid');
                say('');
              }
            },
            { signal }
          );
        }

        disconnectedCallback() {
          this.ac?.abort();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-x-creator"] && !Shopify.designMode) return;
  try {
    
/* Author page · vanilla JS from the prototype (sab-common.js, sab-creators.js), in custom elements. */
/* sab-x-cr-rail · horizontal rows of the author pages (prototype sab-common.js, «File orizzontali» + «Schede»):
   the arrows under the row scroll by one card in the visible track; the tabs (aria-pressed) show one track;
   the «See the series» link follows the visible track (hidden on tabs by type, prototype sab-creators.js). */
if (!customElements.get('sab-x-cr-rail')) {
  class SabXCrRail extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const prev = this.querySelector('[data-rail-prev]');
      const next = this.querySelector('[data-rail-next]');
      const link = this.querySelector('[data-series-link]');
      const tabs = [...this.querySelectorAll('[data-tab-target]')];
      const track = () => this.querySelector('[data-rail-track]:not([hidden])');
      const step = () => (track()?.querySelector(':scope > *')?.getBoundingClientRect().width || 240) + 16;
      const update = () => {
        const t = track();
        if (!t || !prev || !next) return;
        prev.disabled = t.scrollLeft < 8;
        next.disabled = t.scrollLeft + t.clientWidth > t.scrollWidth - 8;
      };
      prev?.addEventListener('click', () => track()?.scrollBy({ left: -step(), behavior: 'smooth' }));
      next?.addEventListener('click', () => track()?.scrollBy({ left: step(), behavior: 'smooth' }));
      this.querySelectorAll('[data-rail-track]').forEach((t) => t.addEventListener('scroll', update, { passive: true }));
      window.addEventListener('resize', update);
      tabs.forEach((tab) => tab.addEventListener('click', () => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-pressed', String(on));
          const panel = document.getElementById(t.dataset.tabTarget);
          if (panel) {
            panel.hidden = !on;
            if (on) panel.scrollLeft = 0;
          }
        });
        if (link) {
          const href = document.getElementById(tab.dataset.tabTarget)?.dataset.seriesHref;
          link.hidden = !href;
          if (href) link.setAttribute('href', href);
        }
        update();
      }));
      update();
    }
  }
  customElements.define('sab-x-cr-rail', SabXCrRail);
}

/* sab-x-cr-gallery · «Flip through the pages» dialog (prototype sab-common.js, «Galleria»): arrows, counter, arrow keys.
   Opening and closing the <dialog> is done by assets/sab-base.js ([data-dialog-open] / [data-dialog-close]). */
if (!customElements.get('sab-x-cr-gallery')) {
  class SabXCrGallery extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const slides = [...this.querySelectorAll('[data-slide]')];
      const count = this.querySelector('[data-gallery-count]');
      let index = 0;
      const show = (n) => {
        if (!slides.length) return;
        index = (n + slides.length) % slides.length;
        slides.forEach((s, i) => { s.hidden = i !== index; });
        if (count) count.textContent = `${index + 1} / ${slides.length}`;
      };
      this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(index - 1));
      this.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(index + 1));
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') show(index + 1);
        if (event.key === 'ArrowLeft') show(index - 1);
      });
      this.sabShow = show;
      show(0);
    }
  }
  customElements.define('sab-x-cr-gallery', SabXCrGallery);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-x-creators"] && !Shopify.designMode) return;
  try {
    
/* Authors & illustrators · vanilla JS from the prototype (sab-creators.js, sab-common.js), in custom elements. */
/* sab-x-cr-rail · horizontal rows of the author pages (prototype sab-common.js, «File orizzontali» + «Schede»):
   the arrows under the row scroll by one card in the visible track; the tabs (aria-pressed) show one track;
   the «See the series» link follows the visible track (hidden on tabs by type, prototype sab-creators.js). */
if (!customElements.get('sab-x-cr-rail')) {
  class SabXCrRail extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const prev = this.querySelector('[data-rail-prev]');
      const next = this.querySelector('[data-rail-next]');
      const link = this.querySelector('[data-series-link]');
      const tabs = [...this.querySelectorAll('[data-tab-target]')];
      const track = () => this.querySelector('[data-rail-track]:not([hidden])');
      const step = () => (track()?.querySelector(':scope > *')?.getBoundingClientRect().width || 240) + 16;
      const update = () => {
        const t = track();
        if (!t || !prev || !next) return;
        prev.disabled = t.scrollLeft < 8;
        next.disabled = t.scrollLeft + t.clientWidth > t.scrollWidth - 8;
      };
      prev?.addEventListener('click', () => track()?.scrollBy({ left: -step(), behavior: 'smooth' }));
      next?.addEventListener('click', () => track()?.scrollBy({ left: step(), behavior: 'smooth' }));
      this.querySelectorAll('[data-rail-track]').forEach((t) => t.addEventListener('scroll', update, { passive: true }));
      window.addEventListener('resize', update);
      tabs.forEach((tab) => tab.addEventListener('click', () => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-pressed', String(on));
          const panel = document.getElementById(t.dataset.tabTarget);
          if (panel) {
            panel.hidden = !on;
            if (on) panel.scrollLeft = 0;
          }
        });
        if (link) {
          const href = document.getElementById(tab.dataset.tabTarget)?.dataset.seriesHref;
          link.hidden = !href;
          if (href) link.setAttribute('href', href);
        }
        update();
      }));
      update();
    }
  }
  customElements.define('sab-x-cr-rail', SabXCrRail);
}

/* sab-x-cr-guess · «Who drew this?» (prototype sab-creators.js): cards that flip. The deck is the JSON [data-guess-pool]
   written by the section. Every round shows 3 different artists; «Play again» picks other pictures, never the ones of the
   round just seen (first the ones not seen yet). The front is a button (aria-expanded); the back is inert until the card
   is flipped; a live region reads the artist. With reduced motion the card does not rotate (CSS). */
if (!customElements.get('sab-x-cr-guess')) {
  class SabXCrGuess extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const poolEl = this.querySelector('[data-guess-pool]');
      if (!poolEl) return;
      let pool;
      try { pool = JSON.parse(poolEl.textContent); } catch (e) { return; }
      const cards = [...this.querySelectorAll('[data-guess-card]')];
      const live = this.querySelector('[data-guess-live]');
      const all = this.querySelector('[data-guess-all]');
      const labels = pool.labels || {};
      const shuffle = (a) => {
        for (let i = a.length - 1; i > 0; i -= 1) {
          const j = Math.floor(Math.random() * (i + 1));
          [a[i], a[j]] = [a[j], a[i]];
        }
        return a;
      };
      let round = cards.map((c) => Number(c.dataset.item));
      let seen = new Set(round);
      const say = (text) => {
        if (!live) return;
        live.textContent = '';
        window.setTimeout(() => { live.textContent = text; }, 60);
      };
      const el = (tag, attrs) => {
        const node = document.createElement(tag);
        Object.entries(attrs || {}).forEach(([k, v]) => node.setAttribute(k, v));
        return node;
      };
      const fill = (card, idx) => {
        const item = pool.items[idx];
        const p = item && pool.people[item.who];
        if (!item || !p) return;
        card.dataset.item = String(idx);
        const art = card.querySelector('.sab-guess__art');
        art.replaceChildren();
        if (item.doodles) {
          art.className = 'sab-guess__art sab-guess__art--doodles';
          art.setAttribute('role', 'img');
          art.setAttribute('aria-label', item.alt || '');
          item.doodles.forEach((src) => art.append(el('img', { src, width: '160', height: '160', alt: '' })));
        } else {
          art.className = 'sab-guess__art';
          art.removeAttribute('role');
          art.removeAttribute('aria-label');
          const book = el('span', { class: 'sab-cover__book', style: `--trim: ${item.tr || '2/3'}${item.ra ? `; --ratio: ${item.ra}` : ''}` });
          book.append(el('img', { class: 'sab-cover__img', src: item.src, width: String(item.w), height: String(item.h), alt: item.alt || '' }));
          art.append(book);
        }
        const ring = card.querySelector('.sab-guess__ring');
        ring.className = p.img ? 'sab-guess__ring' : 'sab-guess__ring sab-guess__ring--initial';
        ring.replaceChildren();
        if (p.img) {
          ring.append(el('img', { src: p.img, width: '188', height: '188', alt: '' }));
        } else {
          const initial = el('span', { class: 'sab-initial', 'aria-hidden': 'true' });
          initial.textContent = p.initial || '';
          ring.append(initial);
        }
        card.querySelector('[data-g="by"]').textContent = item.by || '';
        card.querySelector('[data-g="name"]').textContent = p.name;
        card.querySelector('[data-g="role"]').textContent = p.role || '';
        const link = card.querySelector('[data-g="link"]');
        link.setAttribute('href', p.href);
        link.querySelector('span').textContent = (labels.meet || '{first}').replace('{first}', p.first);
      };
      const reveal = (card) => {
        const item = pool.items[Number(card.dataset.item)];
        return item ? `${item.by} ${pool.people[item.who].name}` : '';
      };
      const set = (card, flipped, focus) => {
        const front = card.querySelector('.sab-guess__front');
        const back = card.querySelector('.sab-guess__back');
        card.classList.toggle('is-flipped', flipped);
        front.setAttribute('aria-expanded', String(flipped));
        back.inert = !flipped;
        front.inert = flipped;
        if (flipped && focus) (back.querySelector('a') || back.querySelector('button'))?.focus({ preventScroll: true });
        if (!flipped && focus) front.focus({ preventScroll: true });
      };
      const syncAll = () => {
        if (!all) return;
        const done = cards.every((c) => c.classList.contains('is-flipped'));
        all.querySelector('span').textContent = done ? (labels.again || '') : (labels.all || '');
        all.dataset.state = done ? 'again' : 'all';
      };
      const newRound = () => {
        const prev = new Set(round);
        if (seen.size >= pool.items.length) seen = new Set(prev);
        const avail = shuffle(pool.items.map((_, i) => i).filter((i) => !prev.has(i)))
          .sort((a, b) => Number(seen.has(a)) - Number(seen.has(b)));
        const byWho = {};
        avail.forEach((i) => { (byWho[pool.items[i].who] ||= []).push(i); });
        const artists = shuffle(Object.keys(byWho)).sort((a, b) => Number(seen.has(byWho[a][0])) - Number(seen.has(byWho[b][0])));
        const picks = artists.slice(0, cards.length).map((w) => byWho[w][0]);
        if (picks.length < cards.length) return;
        round = picks;
        picks.forEach((i) => seen.add(i));
        cards.forEach((c, n) => { set(c, false, false); fill(c, picks[n]); });
      };
      cards.forEach((card) => {
        set(card, false, false);
        card.querySelectorAll('[data-guess-flip]').forEach((btn) => btn.addEventListener('click', () => {
          const flipped = !card.classList.contains('is-flipped');
          set(card, flipped, true);
          if (flipped) say(reveal(card));
          syncAll();
        }));
      });
      all?.addEventListener('click', () => {
        if (all.dataset.state === 'again') {
          newRound();
          say(labels.round || '');
        } else {
          cards.forEach((c) => set(c, true, false));
          say(labels.revealed || '');
        }
        syncAll();
      });
      syncAll();
    }
  }
  customElements.define('sab-x-cr-guess', SabXCrGuess);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-x-faq-page"] && !Shopify.designMode) return;
  try {
    
  /* FAQ (port of sab-faq-page.js): current topic with aria-current while scrolling (only the row scrolls, never the page);
     a link to a question (#q-…) opens it. The parrot waves with CSS (sab-mascot--wave). */
  if (!customElements.get('sab-x-info-faq')) {
    class SabXInfoFaq extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        else this.init();
      }
      init() {
        if (this._ready) return;
        this._ready = true;
        this.links = [...this.querySelectorAll('.sab-faqp-nav__link')];
        this.list = this.querySelector('.sab-faqp-nav__list');
        const groups = this.links.map((a) => document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)))).filter(Boolean);
        if (groups.length) this.setCurrent(groups[0].id, false);
        if ('IntersectionObserver' in window && groups.length) {
          const seen = new Map();
          const io = new IntersectionObserver((entries) => {
            entries.forEach((e) => seen.set(e.target.id, e.isIntersecting ? e.boundingClientRect.top : null));
            const visible = [...seen].filter(([, top]) => top !== null).sort((a, b) => a[1] - b[1]);
            if (visible.length && window.scrollY > 0) this.setCurrent(visible[0][0], true);
          }, { rootMargin: '-25% 0px -55% 0px' });
          groups.forEach((g) => io.observe(g));
        }
        this.openFromHash = this.openFromHash.bind(this);
        window.addEventListener('hashchange', this.openFromHash);
        this.openFromHash();
      }
      disconnectedCallback() {
        window.removeEventListener('hashchange', this.openFromHash);
      }
      setCurrent(id, scrollRow) {
        this.links.forEach((a) => {
          const on = a.getAttribute('href') === `#${id}`;
          if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
          if (on && scrollRow && this.list && this.list.scrollWidth > this.list.clientWidth) {
            const li = a.parentElement;
            this.list.scrollTo({ left: li.offsetLeft - this.list.offsetLeft - 16, behavior: 'smooth' });
          }
        });
      }
      openFromHash() {
        const id = decodeURIComponent(window.location.hash.slice(1));
        const el = id && document.getElementById(id);
        if (el && el.tagName === 'DETAILS' && this.contains(el)) {
          el.open = true;
          el.querySelector('summary')?.focus({ preventScroll: true });
          el.scrollIntoView();
        }
      }
    }
    customElements.define('sab-x-info-faq', SabXInfoFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-x-free-printable"]) return;
  try {
    
  /* sab-x-free-printable · gift landing: email form (only when configured), sticky bar on phones, arrows of the books row.
     The form posts with fetch to the MailerLite form URL of the section setting: no MailerLite script, no cookie before
     sending. Vanilla JS, no libraries. */
  class SabXGiftLanding extends HTMLElement {
    connectedCallback() {
      this.ac = new AbortController();
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.initForm();
      this.initBar();
      this.initRail();
    }

    disconnectedCallback() {
      this.ac?.abort();
      this.io?.disconnect();
      document.body.classList.remove('sab-has-giftbar');
    }

    initForm() {
      const form = this.querySelector('form[data-gift-form]');
      if (!form) return;
      const { signal } = this.ac;
      const input = form.querySelector('input[type="email"]');
      const error = form.querySelector('[data-form-error]');
      const fields = form.querySelector('[data-form-fields]');
      const done = form.querySelector('[data-form-done]');
      const button = form.querySelector('button[type="submit"]');
      const consent = form.querySelector('[data-consent-box]');
      if (!input || !error || !button) return;

      const say = (text) => {
        error.textContent = text || '';
        error.hidden = !text;
      };

      form.addEventListener(
        'submit',
        async (event) => {
          event.preventDefault();
          const value = input.value.trim();
          const key = !value ? 'empty' : /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value) ? '' : 'invalid';
          input.setAttribute('aria-invalid', String(Boolean(key)));
          if (key) {
            say(form.dataset[key === 'empty' ? 'msgEmpty' : 'msgInvalid']);
            input.focus();
            return;
          }
          if (consent && !consent.checked) {
            say(form.dataset.msgConsent);
            consent.focus();
            return;
          }
          say('');
          const box = form.querySelector('[data-optin-box]');
          const optin = form.querySelector('[data-optin-value]');
          if (box && optin) optin.value = box.checked ? 'yes' : 'no';

          const showDone = () => {
            if (fields && done) {
              fields.hidden = true;
              done.hidden = false;
              done.focus();
            }
            this.updateBar?.();
          };

          const trap = form.querySelector('[name="sab_hp"]');
          if (trap && trap.value) {
            showDone();
            return;
          }
          const action = form.getAttribute('action');
          const send = window.SAB && window.SAB.mlSubmit;
          if (!action || typeof send !== 'function') {
            say(form.dataset.msgFail);
            return;
          }
          input.value = value;
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          /* «done» ONLY when MailerLite answers { success: true } (JSONP, SAB.mlSubmit); otherwise the error, button active again */
          const ok = await send(form, action);
          button.disabled = false;
          button.removeAttribute('aria-busy');
          if (ok) showDone();
          else say(form.dataset.msgFail);
        },
        { signal }
      );
      input.addEventListener(
        'input',
        () => {
          if (input.getAttribute('aria-invalid') === 'true') {
            input.removeAttribute('aria-invalid');
            say('');
          }
        },
        { signal }
      );
    }

    initBar() {
      const bar = this.querySelector('[data-gift-bar]');
      const anchor = this.querySelector('[data-gift-anchor]');
      if (!bar || !anchor || !('IntersectionObserver' in window)) return;
      const { signal } = this.ac;
      const mobile = window.matchMedia('(max-width: 63.99rem)');
      let offscreen = false;
      this.updateBar = () => {
        const sent = anchor.querySelector('[data-form-done]:not([hidden])');
        const show = mobile.matches && offscreen && !sent;
        bar.hidden = !show;
        document.body.classList.toggle('sab-has-giftbar', show);
      };
      this.io = new IntersectionObserver(([entry]) => {
        offscreen = !entry.isIntersecting;
        this.updateBar();
      });
      this.io.observe(anchor);
      mobile.addEventListener('change', this.updateBar, { signal });
      const jump = bar.querySelector('[data-gift-jump]');
      jump?.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          anchor.scrollIntoView({ behavior: this.reduce ? 'auto' : 'smooth', block: 'start' });
          window.setTimeout(
            () => anchor.querySelector('input[type="email"]')?.focus({ preventScroll: true }),
            this.reduce ? 0 : 450
          );
        },
        { signal }
      );
    }

    initRail() {
      const { signal } = this.ac;
      this.querySelectorAll('[data-sab-rail]').forEach((rail) => {
        const prev = rail.querySelector('[data-rail-prev]');
        const next = rail.querySelector('[data-rail-next]');
        const track = rail.querySelector('[data-rail-track]');
        if (!prev || !next || !track) return;
        const step = () => (track.querySelector(':scope > *')?.getBoundingClientRect().width || 240) + 16;
        const update = () => {
          prev.disabled = track.scrollLeft < 8;
          next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8;
        };
        const behavior = this.reduce ? 'auto' : 'smooth';
        prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior }), { signal });
        next.addEventListener('click', () => track.scrollBy({ left: step(), behavior }), { signal });
        track.addEventListener('scroll', update, { passive: true, signal });
        window.addEventListener('resize', update, { signal });
        update();
      });
    }
  }

  if (!customElements.get('sab-x-gift-landing')) customElements.define('sab-x-gift-landing', SabXGiftLanding);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-x-free-printables"] && !Shopify.designMode) return;
  try {
    
  /* sab-x-free-printables · the Lil Parrot question filters the cards (?for=kids preselects) and the readers carousel.
     Vanilla JS, no libraries. */
  class SabXFreePrintables extends HTMLElement {
    connectedCallback() {
      this.ac = new AbortController();
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.initFilters();
      this.initSnaps();
    }

    disconnectedCallback() {
      this.ac?.abort();
    }

    initFilters() {
      const group = this.querySelector('[data-gift-filters]');
      const grid = this.querySelector('[data-gift-grid]');
      const bubble = this.querySelector('[data-parrot-bubble]');
      if (!group || !grid || !bubble) return;
      const { signal } = this.ac;
      const buttons = [...group.querySelectorAll('[data-filter]')];
      const items = [...grid.querySelectorAll(':scope > [data-tags]')];
      const select = (btn, fromUser) => {
        const filter = btn.dataset.filter;
        let shown = 0;
        buttons.forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
        items.forEach((item) => {
          const tags = (item.dataset.tags || '').split(/\s+/);
          const match = filter === 'all' || tags.includes(filter);
          item.hidden = !match;
          if (match) shown += 1;
        });
        if (!fromUser) return;
        const say = btn.dataset.say;
        if (say) {
          bubble.textContent = say.replace('{n}', String(shown));
          if (!this.reduce) {
            bubble.classList.remove('is-pop');
            void bubble.offsetWidth;
            bubble.classList.add('is-pop');
          }
        }
        const url = new URL(window.location.href);
        if (filter === 'all') url.searchParams.delete('for');
        else url.searchParams.set('for', filter);
        window.history.replaceState(window.history.state, '', url);
      };
      buttons.forEach((btn) => btn.addEventListener('click', () => select(btn, true), { signal }));
      const wanted = new URLSearchParams(window.location.search).get('for');
      const start = buttons.find((b) => b.dataset.filter === wanted);
      if (start) select(start, true);
    }

    initSnaps() {
      const { signal } = this.ac;
      this.querySelectorAll('[data-snaps]').forEach((root) => {
        const track = root.querySelector('[data-snaps-track]');
        const prev = root.querySelector('[data-snaps-prev]');
        const next = root.querySelector('[data-snaps-next]');
        const count = root.querySelector('[data-snaps-count]');
        const live = root.querySelector('[data-snaps-live]');
        if (!track || !prev || !next || !count) return;
        const slides = [...track.children];
        if (!slides.length) return;
        const visible = () =>
          slides
            .map((el, i) => ({ i, x: el.offsetLeft - track.scrollLeft, w: el.offsetWidth }))
            .filter(({ x, w }) => x >= -2 && x + w <= track.clientWidth + 2);
        let announce = false;
        const update = () => {
          const v = visible();
          const first = v.length ? v[0].i + 1 : 1;
          const last = v.length ? v[v.length - 1].i + 1 : 1;
          const n = slides.length;
          count.textContent = `${first === last ? first : `${first}-${last}`} / ${n}`;
          prev.disabled = track.scrollLeft < 4;
          next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 4;
          if (announce && live) {
            live.textContent = first === last ? `Photo ${first} of ${n}` : `Photos ${first} to ${last} of ${n}`;
          }
        };
        const go = (dir) => {
          announce = true;
          const v = visible();
          const per = Math.max(1, v.length);
          const first = v.length ? v[0].i : 0;
          const target = Math.min(slides.length - 1, Math.max(0, first + dir * per));
          const padL = parseFloat(getComputedStyle(track).paddingLeft) || 0;
          track.scrollTo({ left: slides[target].offsetLeft - padL, behavior: this.reduce ? 'auto' : 'smooth' });
        };
        prev.addEventListener('click', () => go(-1), { signal });
        next.addEventListener('click', () => go(1), { signal });
        let raf = 0;
        track.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(update);
          },
          { passive: true, signal }
        );
        window.addEventListener('resize', update, { signal });
        update();
      });
    }
  }

  if (!customElements.get('sab-x-free-printables')) customElements.define('sab-x-free-printables', SabXFreePrintables);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-x-rights-inquiry"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sab-x-info-form')) {
    const SAB_X_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const SAB_X_T = {
      required: 'Please fill in this field.',
      select: 'Please choose an option.',
      email: 'That email doesn’t look right. Please check it and try again.',
      consent: 'Please tick the box so we can reply to you.',
      summary: 'Please check these fields:'
    };
    const SAB_X_KEY = 'sab-x-info-last-form';
    class SabXInfoForm extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        else this.init();
      }
      init() {
        if (this._ready) return;
        this.form = this.querySelector('form');
        if (!this.form) return;
        this._ready = true;
        this.form.noValidate = true;
        this.summary = this.querySelector('[data-form-summary]');
        this.fields = [...this.form.querySelectorAll('input:not([type="hidden"]), select, textarea')].filter((f) => f.required);
        this.tried = false;
        this.fields.forEach((f) => {
          f.addEventListener(f.type === 'checkbox' || f.tagName === 'SELECT' ? 'change' : 'blur', () => { if (this.tried) this.check(f); });
        });
        this.form.addEventListener('submit', (event) => this.onSubmit(event));
        if (this.summary) {
          this.summary.addEventListener('click', (event) => {
            const a = event.target.closest('a[href^="#"]');
            if (!a) return;
            event.preventDefault();
            document.getElementById(a.getAttribute('href').slice(1))?.focus();
          });
        }
        this.querySelectorAll('select[data-topic-hint]').forEach((select) => {
          const hint = document.getElementById(select.dataset.topicHint);
          const update = () => { if (hint) hint.hidden = select.value !== hint.dataset.whenValue; };
          select.addEventListener('change', update);
          update();
        });
        this.markPosted();
      }
      labelOf(f) {
        if (f.dataset.summary) return f.dataset.summary;
        const l = this.form.querySelector(`label[for="${f.id}"]`);
        return (l ? l.textContent.trim().replace(/\s*\(.*\)$/, '') : '') || f.name;
      }
      check(f) {
        let msg = '';
        if (f.type === 'checkbox') { if (!f.checked) msg = SAB_X_T.consent; }
        else if (!f.value.trim()) msg = f.tagName === 'SELECT' ? SAB_X_T.select : SAB_X_T.required;
        else if (f.type === 'email' && !SAB_X_EMAIL.test(f.value.trim())) msg = SAB_X_T.email;
        const wrap = f.closest('.sab-field');
        const err = document.getElementById(`${f.id}-err`);
        if (wrap) wrap.classList.toggle('is-invalid', Boolean(msg));
        f.setAttribute('aria-invalid', String(Boolean(msg)));
        if (err) { err.textContent = msg; err.hidden = !msg; }
        const ids = (f.getAttribute('aria-describedby') || '').split(' ').filter((x) => x && x !== `${f.id}-err`);
        if (msg) ids.push(`${f.id}-err`);
        if (ids.length) f.setAttribute('aria-describedby', ids.join(' ')); else f.removeAttribute('aria-describedby');
        return msg;
      }
      onSubmit(event) {
        if (this.go) return;
        this.tried = true;
        const bad = this.fields.filter((f) => this.check(f));
        if (bad.length) {
          event.preventDefault();
          if (this.summary) {
            const items = bad.map((f) => `<li><a href="#${f.id}">${this.labelOf(f)}</a></li>`).join('');
            this.summary.innerHTML = `<p>${SAB_X_T.summary}</p><ul>${items}</ul>`;
            this.summary.hidden = false;
            this.summary.focus();
          } else bad[0].focus();
          return;
        }
        if (this.summary) this.summary.hidden = true;
        try { window.sessionStorage.setItem(SAB_X_KEY, this.form.id); } catch (e) { /* storage off */ }
        const action = (this.dataset.mlAction || '').trim();
        if (!action) return;
        event.preventDefault();
        this.classList.add('is-busy');
        const data = new FormData();
        this.form.querySelectorAll('[data-ml]').forEach((f) => { if (f.value.trim()) data.append(`fields[${f.dataset.ml}]`, f.value.trim()); });
        data.append('ml-submit', '1');
        data.append('anticsrf', 'true');
        const ctrl = 'AbortController' in window ? new AbortController() : null;
        const timer = window.setTimeout(() => { if (ctrl) ctrl.abort(); }, 6000);
        const submitter = event.submitter && event.submitter.form === this.form ? event.submitter : undefined;
        fetch(action, { method: 'POST', body: data, mode: 'no-cors', signal: ctrl ? ctrl.signal : undefined })
          .catch(() => {})
          .finally(() => {
            window.clearTimeout(timer);
            this.go = true;
            if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit(submitter);
            else this.form.submit();
          });
      }
      markPosted() {
        if (!this.querySelector('[data-form-state]')) return;
        const posted = [...document.querySelectorAll('sab-x-info-form')].filter((el) => el.querySelector('form') && el.querySelector('[data-form-state]'));
        const ids = posted.map((el) => el.querySelector('form').id);
        const hash = decodeURIComponent(window.location.hash.slice(1));
        let last = null;
        try { last = window.sessionStorage.getItem(SAB_X_KEY); } catch (e) { /* storage off */ }
        let current = null;
        if (ids.includes(hash)) current = hash;
        else if (last && ids.includes(last)) current = last;
        else {
          const primary = posted.find((el) => el.hasAttribute('data-primary')) || posted[0];
          current = primary ? primary.querySelector('form').id : null;
        }
        if (current !== this.form.id) return;
        this.classList.add('is-current');
        const panel = this.closest('[data-catalog-panel]');
        if (panel) panel.classList.add('is-open');
        const msg = this.querySelector('.sab-x-msg');
        if (msg) window.requestAnimationFrame(() => { msg.focus(); msg.scrollIntoView({ block: 'center' }); });
      }
    }
    customElements.define('sab-x-info-form', SabXInfoForm);
  }

  if (!window.sabXInfoLinks) {
    window.sabXInfoLinks = true;
    document.addEventListener('click', (event) => {
      /* «Get the 2026 catalog»: opens the Rights Catalog request */
      const opener = event.target.closest('[data-open-catalog]');
      if (opener) {
        const panel = document.getElementById(opener.dataset.openCatalog);
        if (panel) {
          panel.classList.add('is-open');
          window.setTimeout(() => { panel.querySelector('input:not([type="hidden"])')?.focus({ preventScroll: true }); }, 60);
        }
      }
      /* Links that fill in a field (e.g. «Become a retail partner» → role Bookseller); a written message is never replaced */
      const setter = event.target.closest('[data-set-field]');
      if (setter) {
        const [id, value] = setter.dataset.setField.split('=');
        const field = document.getElementById(id);
        if (field && value && !(field.tagName === 'TEXTAREA' && field.value.trim())) {
          field.value = value;
          field.dispatchEvent(new Event('change'));
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-x-rights-titles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sab-x-info-rail')) {
    class SabXInfoRail extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        else this.init();
      }
      init() {
        if (this._ready) return;
        this._ready = true;
        const track = this.querySelector('[data-rail-track]');
        const prev = this.querySelector('[data-rail-prev]');
        const next = this.querySelector('[data-rail-next]');
        if (!track || !prev || !next) return;
        const step = () => (track.querySelector(':scope > *')?.getBoundingClientRect().width || 240) + 16;
        const update = () => {
          prev.disabled = track.scrollLeft < 8;
          next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8;
        };
        prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
        next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }
    }
    customElements.define('sab-x-info-rail', SabXInfoRail);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-x-rights-trade"] && !Shopify.designMode) return;
  try {
    
  if (!window.sabXInfoLinks) {
    window.sabXInfoLinks = true;
    document.addEventListener('click', (event) => {
      /* «Get the 2026 catalog»: opens the Rights Catalog request */
      const opener = event.target.closest('[data-open-catalog]');
      if (opener) {
        const panel = document.getElementById(opener.dataset.openCatalog);
        if (panel) {
          panel.classList.add('is-open');
          window.setTimeout(() => { panel.querySelector('input:not([type="hidden"])')?.focus({ preventScroll: true }); }, 60);
        }
      }
      /* Links that fill in a field (e.g. «Become a retail partner» → role Bookseller); a written message is never replaced */
      const setter = event.target.closest('[data-set-field]');
      if (setter) {
        const [id, value] = setter.dataset.setField.split('=');
        const field = document.getElementById(id);
        if (field && value && !(field.tagName === 'TEXTAREA' && field.value.trim())) {
          field.value = value;
          field.dispatchEvent(new Event('change'));
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sab-x-rights"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sab-x-info-form')) {
    const SAB_X_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    const SAB_X_T = {
      required: 'Please fill in this field.',
      select: 'Please choose an option.',
      email: 'That email doesn’t look right. Please check it and try again.',
      consent: 'Please tick the box so we can reply to you.',
      summary: 'Please check these fields:'
    };
    const SAB_X_KEY = 'sab-x-info-last-form';
    class SabXInfoForm extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        else this.init();
      }
      init() {
        if (this._ready) return;
        this.form = this.querySelector('form');
        if (!this.form) return;
        this._ready = true;
        this.form.noValidate = true;
        this.summary = this.querySelector('[data-form-summary]');
        this.fields = [...this.form.querySelectorAll('input:not([type="hidden"]), select, textarea')].filter((f) => f.required);
        this.tried = false;
        this.fields.forEach((f) => {
          f.addEventListener(f.type === 'checkbox' || f.tagName === 'SELECT' ? 'change' : 'blur', () => { if (this.tried) this.check(f); });
        });
        this.form.addEventListener('submit', (event) => this.onSubmit(event));
        if (this.summary) {
          this.summary.addEventListener('click', (event) => {
            const a = event.target.closest('a[href^="#"]');
            if (!a) return;
            event.preventDefault();
            document.getElementById(a.getAttribute('href').slice(1))?.focus();
          });
        }
        this.querySelectorAll('select[data-topic-hint]').forEach((select) => {
          const hint = document.getElementById(select.dataset.topicHint);
          const update = () => { if (hint) hint.hidden = select.value !== hint.dataset.whenValue; };
          select.addEventListener('change', update);
          update();
        });
        this.markPosted();
      }
      labelOf(f) {
        if (f.dataset.summary) return f.dataset.summary;
        const l = this.form.querySelector(`label[for="${f.id}"]`);
        return (l ? l.textContent.trim().replace(/\s*\(.*\)$/, '') : '') || f.name;
      }
      check(f) {
        let msg = '';
        if (f.type === 'checkbox') { if (!f.checked) msg = SAB_X_T.consent; }
        else if (!f.value.trim()) msg = f.tagName === 'SELECT' ? SAB_X_T.select : SAB_X_T.required;
        else if (f.type === 'email' && !SAB_X_EMAIL.test(f.value.trim())) msg = SAB_X_T.email;
        const wrap = f.closest('.sab-field');
        const err = document.getElementById(`${f.id}-err`);
        if (wrap) wrap.classList.toggle('is-invalid', Boolean(msg));
        f.setAttribute('aria-invalid', String(Boolean(msg)));
        if (err) { err.textContent = msg; err.hidden = !msg; }
        const ids = (f.getAttribute('aria-describedby') || '').split(' ').filter((x) => x && x !== `${f.id}-err`);
        if (msg) ids.push(`${f.id}-err`);
        if (ids.length) f.setAttribute('aria-describedby', ids.join(' ')); else f.removeAttribute('aria-describedby');
        return msg;
      }
      onSubmit(event) {
        if (this.go) return;
        this.tried = true;
        const bad = this.fields.filter((f) => this.check(f));
        if (bad.length) {
          event.preventDefault();
          if (this.summary) {
            const items = bad.map((f) => `<li><a href="#${f.id}">${this.labelOf(f)}</a></li>`).join('');
            this.summary.innerHTML = `<p>${SAB_X_T.summary}</p><ul>${items}</ul>`;
            this.summary.hidden = false;
            this.summary.focus();
          } else bad[0].focus();
          return;
        }
        if (this.summary) this.summary.hidden = true;
        try { window.sessionStorage.setItem(SAB_X_KEY, this.form.id); } catch (e) { /* storage off */ }
        const action = (this.dataset.mlAction || '').trim();
        if (!action) return;
        event.preventDefault();
        this.classList.add('is-busy');
        const data = new FormData();
        this.form.querySelectorAll('[data-ml]').forEach((f) => { if (f.value.trim()) data.append(`fields[${f.dataset.ml}]`, f.value.trim()); });
        data.append('ml-submit', '1');
        data.append('anticsrf', 'true');
        const ctrl = 'AbortController' in window ? new AbortController() : null;
        const timer = window.setTimeout(() => { if (ctrl) ctrl.abort(); }, 6000);
        const submitter = event.submitter && event.submitter.form === this.form ? event.submitter : undefined;
        fetch(action, { method: 'POST', body: data, mode: 'no-cors', signal: ctrl ? ctrl.signal : undefined })
          .catch(() => {})
          .finally(() => {
            window.clearTimeout(timer);
            this.go = true;
            if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit(submitter);
            else this.form.submit();
          });
      }
      markPosted() {
        if (!this.querySelector('[data-form-state]')) return;
        const posted = [...document.querySelectorAll('sab-x-info-form')].filter((el) => el.querySelector('form') && el.querySelector('[data-form-state]'));
        const ids = posted.map((el) => el.querySelector('form').id);
        const hash = decodeURIComponent(window.location.hash.slice(1));
        let last = null;
        try { last = window.sessionStorage.getItem(SAB_X_KEY); } catch (e) { /* storage off */ }
        let current = null;
        if (ids.includes(hash)) current = hash;
        else if (last && ids.includes(last)) current = last;
        else {
          const primary = posted.find((el) => el.hasAttribute('data-primary')) || posted[0];
          current = primary ? primary.querySelector('form').id : null;
        }
        if (current !== this.form.id) return;
        this.classList.add('is-current');
        const panel = this.closest('[data-catalog-panel]');
        if (panel) panel.classList.add('is-open');
        const msg = this.querySelector('.sab-x-msg');
        if (msg) window.requestAnimationFrame(() => { msg.focus(); msg.scrollIntoView({ block: 'center' }); });
      }
    }
    customElements.define('sab-x-info-form', SabXInfoForm);
  }

  if (!window.sabXInfoLinks) {
    window.sabXInfoLinks = true;
    document.addEventListener('click', (event) => {
      /* «Get the 2026 catalog»: opens the Rights Catalog request */
      const opener = event.target.closest('[data-open-catalog]');
      if (opener) {
        const panel = document.getElementById(opener.dataset.openCatalog);
        if (panel) {
          panel.classList.add('is-open');
          window.setTimeout(() => { panel.querySelector('input:not([type="hidden"])')?.focus({ preventScroll: true }); }, 60);
        }
      }
      /* Links that fill in a field (e.g. «Become a retail partner» → role Bookseller); a written message is never replaced */
      const setter = event.target.closest('[data-set-field]');
      if (setter) {
        const [id, value] = setter.dataset.setField.split('=');
        const field = document.getElementById(id);
        if (field && value && !(field.tagName === 'TEXTAREA' && field.value.trim())) {
          field.value = value;
          field.dispatchEvent(new Event('change'));
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
